/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date scalar representing a calendar date in YYYY-MM-DD format (e.g., 2024-03-15). */
  Date: { input: any; output: any; }
  /** DateTime scalar representing a timestamp in ISO 8601 format (e.g., 2024-03-15T14:30:00Z). */
  DateTime: { input: any; output: any; }
};

/** Input for creating or updating an API client. */
export type ApiClientInput = {
  /** Whether the client is active and can authenticate */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the API client (required) */
  id: Scalars['String']['input'];
  /** Array of manager IDs this client is authorized to access */
  manager_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Display name for the client */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Plain text password/secret - will be hashed before storage.
   * Only provide when creating a new client or changing the secret.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Optional schema preset for the client (e.g., "full", "partner"). Maps to a pre-defined set of scopes. */
  schema?: InputMaybe<Scalars['String']['input']>;
  /** Optional explicit scopes, additive to any scopes from the schema. */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Physical address of a property. */
export type Address = {
  __typename?: 'Address';
  /** City name */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name or code */
  country?: Maybe<Scalars['String']['output']>;
  /** Postal/ZIP code */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** State or province */
  state_prov?: Maybe<Scalars['String']['output']>;
  /** Street address line 1 */
  street?: Maybe<Scalars['String']['output']>;
  /** Street address line 2 (unit, suite, etc.) */
  street2?: Maybe<Scalars['String']['output']>;
};

/** Input for creating/updating an address. */
export type AddressInput = {
  /** City name */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country name or code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Postal/ZIP code */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** State or province */
  state_prov?: InputMaybe<Scalars['String']['input']>;
  /** Street address line 1 */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Street address line 2 (unit, suite, etc.) */
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** A single announcement (e.g. banner, CTA) with optional call-to-action. */
export type Announcement = {
  __typename?: 'Announcement';
  /** Whether the announcement is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Call-to-action label */
  cta_text?: Maybe<Scalars['String']['output']>;
  /** Call-to-action URL */
  cta_url?: Maybe<Scalars['String']['output']>;
  /** Rich text or HTML details */
  details?: Maybe<Scalars['String']['output']>;
  /** Datetime the announcement should stop displaying */
  end_datetime?: Maybe<Scalars['DateTime']['output']>;
  /** Property manager ID (determines access control) */
  manager_id?: Maybe<Scalars['String']['output']>;
  /** Display name / title */
  name?: Maybe<Scalars['String']['output']>;
  /** Datetime the announcement should start displaying */
  start_datetime?: Maybe<Scalars['DateTime']['output']>;
  /** Announcement type/category */
  type?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the announcement */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Input for creating or updating an announcement. */
export type AnnouncementInput = {
  /** Whether the announcement is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Call-to-action label */
  cta_text?: InputMaybe<Scalars['String']['input']>;
  /** Call-to-action URL */
  cta_url?: InputMaybe<Scalars['String']['input']>;
  /** Text max 2000 characters */
  details: Scalars['String']['input'];
  /** Datetime the announcement should stop displaying */
  end_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Property manager ID (determines access control) */
  manager_id?: InputMaybe<Scalars['String']['input']>;
  /** Display name / title */
  name: Scalars['String']['input'];
  /** Datetime the announcement should start displaying */
  start_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Announcement type/category */
  type: Scalars['String']['input'];
  /** Unique identifier for the announcement */
  uuid: Scalars['String']['input'];
};

/** Input for querying announcements with optional pagination. */
export type AnnouncementsQueryInput = {
  /** Pagination controls */
  page?: InputMaybe<PageInput>;
};

/** Response from an announcements query. */
export type AnnouncementsQueryOutput = {
  __typename?: 'AnnouncementsQueryOutput';
  /** Array of announcements matching the query criteria */
  announcements: Array<Announcement>;
};

/** Arguments for array fields like images. */
export type ArrayArgsInput = {
  /** Limit to first N items */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Brand configuration that maps manager IDs to URL base paths for listings and resorts.
 * Each brand config can be associated with one or more manager IDs.
 */
export type BrandConfig = {
  __typename?: 'BrandConfig';
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Manager IDs associated with this brand */
  manager_ids: Array<Scalars['String']['output']>;
  /** Display name for this brand */
  name?: Maybe<Scalars['String']['output']>;
  /** URL path configuration for this brand */
  paths?: Maybe<BrandConfigPaths>;
};

/** Input for creating or updating a brand configuration. */
export type BrandConfigInput = {
  /** Unique identifier (required) */
  id: Scalars['String']['input'];
  /** Manager IDs associated with this brand */
  manager_ids: Array<Scalars['String']['input']>;
  /** Display name for this brand */
  name?: InputMaybe<Scalars['String']['input']>;
  /** URL path configuration for this brand */
  paths?: InputMaybe<BrandConfigPathsInput>;
};

/** URL path configuration for a brand, defining base paths for different resource types. */
export type BrandConfigPaths = {
  __typename?: 'BrandConfigPaths';
  /** Base URL path for listings (e.g., "https://example.com/rentals") */
  listings?: Maybe<Scalars['String']['output']>;
  /** Base URL path for resorts (e.g., "https://example.com/resorts") */
  resorts?: Maybe<Scalars['String']['output']>;
};

/** Input for brand URL path configuration. */
export type BrandConfigPathsInput = {
  /** Base URL path for listings (e.g., "https://example.com/rentals") */
  listings?: InputMaybe<Scalars['String']['input']>;
  /** Base URL path for resorts (e.g., "https://example.com/resorts") */
  resorts?: InputMaybe<Scalars['String']['input']>;
};

/** Calendar date entry showing availability for a specific night. */
export type CalendarDate = {
  __typename?: 'CalendarDate';
  /** If true, the night of cal_date is currently available on the calendar. */
  available: Scalars['Boolean']['output'];
  /** The calendar date.  This date represents the night of cal_date available for rent. */
  cal_date: Scalars['Date']['output'];
  /** If true, the date is available for a checkin on cal_date. */
  checkin?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the date is available for a checkout on cal_date. */
  checkout?: Maybe<Scalars['Boolean']['output']>;
  /** The minimum number of nights that can be booked with an arrival on cal_date. */
  min_stay?: Maybe<Scalars['Int']['output']>;
  /**
   * If true, the date is not available for a stay over on the night of cal_date.  May arrive
   * or depart depending on checkin or checkout.
   */
  no_stay?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The rate for the date.  This is an indicative rate and may not be valid in
   * length of stay priced listings.
   */
  rate?: Maybe<Scalars['Float']['output']>;
  /**
   * Stay ranges indicate the lengths of stay that are currently available to be booked
   * with an arrival on cal_date.  This is a collection of StayRange objects indicating
   * a range of stay lengths available.  For example, a stay_ranges of [{from: 1, to: 3}, {from: 5, to: 7}]
   * indicates that stays of 1, 2, 3, 5, 6, or 7 nights are available to be booked with an arrival on
   * cal_date.  A stay_ranges of [{from: 7, to: 7}] indicates that only 7-night stays are available.
   */
  stay_ranges?: Maybe<Array<StayRange>>;
};

/** The CalendarDateInput type is used to update the calendar availability for a listing. */
export type CalendarDateInput = {
  /** If true, the night of cal_date is currently available on the calendar. */
  available: Scalars['Boolean']['input'];
  /** The calendar date.  This date represents the night of cal_date available for rent. */
  cal_date: Scalars['Date']['input'];
  /** If true, the date is available for a checkin on cal_date. */
  checkin?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the date is available for a checkout on cal_date. */
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum number of nights that can be booked with an arrival on cal_date. */
  min_stay?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, the date is not available for a stay over on the night of cal_date.  May arrive
   * or depart depending on checkin or checkout.
   */
  no_stay?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The rate for the date.  This is an indicative rate and may not be valid in
   * length of stay priced listings.
   */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Stay ranges indicate the lengths of stay that are currently available to be booked
   * with an arrival on cal_date.  This is a collection of StayRangeInput objects indicating
   * a range of stay lengths available.  For example, a stay_ranges of [{from: 1, to: 3}, {from: 5, to: 7}] indicates that
   * stays of 1, 2, 3, 5, 6, or 7 nights are available to be booked with an arrival on
   * cal_date.  A stay_ranges of [{from: 7, to: 7}] indicates that only 7-night stays are available.
   */
  stay_ranges?: InputMaybe<Array<StayRangeInput>>;
};

/** Arguments for querying calendar availability. */
export type CalendarDatesArgsInput = {
  /** Date range to retrieve calendar entries for */
  dates?: InputMaybe<DateRangeInput>;
};

/** Cancellation policy for a listing. */
export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  /** Whether fully refundable */
  fully_refundable: Scalars['Boolean']['output'];
  /** Grace period in hours for full refund */
  grace_period: Scalars['Int']['output'];
  /** Days before check-in when policy applies */
  nights_before_check_in: Scalars['Int']['output'];
  /** Refund percentage if cancelled within policy */
  refund_percent: Scalars['Int']['output'];
};

/** Input for cancellation policy settings. */
export type CancellationPolicyInput = {
  /** Whether booking is fully refundable */
  fully_refundable: Scalars['Boolean']['input'];
  /** Grace period in hours for full refund after booking */
  grace_period: Scalars['Int']['input'];
  /** Days before check-in when policy applies */
  nights_before_check_in: Scalars['Int']['input'];
  /** Refund percentage if cancelled within policy */
  refund_percent: Scalars['Int']['input'];
};

/** Date range for filtering queries. */
export type DateRangeInput = {
  /** Start date (inclusive) */
  first?: InputMaybe<Scalars['Date']['input']>;
  /** End date (inclusive) */
  last?: InputMaybe<Scalars['Date']['input']>;
};

/**
 * End-user context for personalization. Bundles visitor identity, browsing
 * context, and request metadata so every personalization touchpoint receives
 * consistent data. The SSR layer should populate ip and user_agent from the
 * original browser request.
 */
export type EndUserContextInput = {
  /** Client identifier (e.g. Google Analytics Client ID) */
  cid: Scalars['String']['input'];
  /** Full URL of the page the end user is currently browsing */
  full_url: Scalars['String']['input'];
  /** End user's IP address. SSR should forward from original request. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /**
   * Personalization realm identifier. Identifies the personalization tenant
   * (e.g. Aidaptive customer ID). When omitted, personalization is skipped.
   */
  personalization_realm?: InputMaybe<Scalars['String']['input']>;
  /** Ranking context. Defaults to SEARCH if omitted. */
  usage?: InputMaybe<PersonalizationUsage>;
  /** End user's User-Agent string. SSR should forward from original request. */
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** Facet result for boolean values. */
export type FacetBoolean = {
  __typename?: 'FacetBoolean';
  /** Number of listings with this value */
  count: Scalars['Int']['output'];
  /** The boolean value */
  value: Scalars['Boolean']['output'];
};

/** Facet result for features/amenities. */
export type FacetFeature = {
  __typename?: 'FacetFeature';
  /** Number of listings with this feature */
  count: Scalars['Int']['output'];
  /** The feature name */
  value: Scalars['String']['output'];
};

/** Facet result for numeric values. */
export type FacetNumber = {
  __typename?: 'FacetNumber';
  /** Number of listings with this value */
  count: Scalars['Int']['output'];
  /** The numeric value (e.g., bedroom count, price bucket) */
  value: Scalars['Float']['output'];
};

/** Facet result for resorts, including resort details. */
export type FacetResort = {
  __typename?: 'FacetResort';
  /** Number of listings at this resort */
  count: Scalars['Int']['output'];
  /** Resort ID */
  id: Scalars['String']['output'];
  /** Resort name */
  name: Scalars['String']['output'];
};

/** Facet result for string values. */
export type FacetString = {
  __typename?: 'FacetString';
  /** Number of listings with this value */
  count: Scalars['Int']['output'];
  /** The string value (e.g., view type, unit type) */
  value: Scalars['String']['output'];
};

/** A feature or amenity with optional categorization. */
export type FeatureDetail = {
  __typename?: 'FeatureDetail';
  /** Feature category (e.g., Kitchen, Bathroom) */
  category?: Maybe<Scalars['String']['output']>;
  /** Additional detail about the feature */
  detail?: Maybe<Scalars['String']['output']>;
  /** Feature name */
  name: Scalars['String']['output'];
  /** Feature value or description */
  value: Scalars['String']['output'];
};

/** Input for creating/updating a feature. */
export type FeatureDetailInput = {
  /** Feature category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Additional detail */
  detail?: InputMaybe<Scalars['String']['input']>;
  /** Feature name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Feature value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Enumeration to allow flagging different fee types in the fee_details object. */
export enum FeeType {
  Booking = 'BOOKING',
  Damage = 'DAMAGE',
  Rent = 'RENT',
  Resort = 'RESORT',
  Service = 'SERVICE'
}

/** Filter input for date fields. */
export type FilterDateInput = {
  /** The comparison type to use */
  type?: InputMaybe<FilterDateType>;
  /** Date values to compare against */
  values?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Filter input for datetime fields. */
export type FilterDateTimeInput = {
  /** The comparison type to use */
  type?: InputMaybe<FilterDateType>;
  /** DateTime values to compare against (ISO 8601) */
  values?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Date filter comparison types.
 * BETWEEN/NOT_BETWEEN require exactly 2 values.
 * Other types require exactly 1 value.
 */
export enum FilterDateType {
  /** Match if date is between values[0] and values[1] inclusive */
  Between = 'BETWEEN',
  /** Match if date equals values[0] */
  Equals = 'EQUALS',
  /** Match if date is after values[0] */
  GreaterThan = 'GREATER_THAN',
  /** Match if date is on or after values[0] */
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  /** Match if date is before values[0] */
  LessThan = 'LESS_THAN',
  /** Match if date is on or before values[0] */
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  /** Match if date is NOT between values[0] and values[1] */
  NotBetween = 'NOT_BETWEEN',
  /** Match if date does not equal values[0] */
  NotEquals = 'NOT_EQUALS'
}

/**
 * Filter by distance from a geographic point.
 * Returns results within the specified radius.
 */
export type FilterLocationDistanceInput = {
  /** Maximum distance in meters from the center point */
  distanceMeters: Scalars['Float']['input'];
  /** Center point for the distance calculation */
  point: GeoPointInput;
};

/**
 * Filter by location within a polygon boundary.
 * Returns results whose location falls inside the polygon.
 */
export type FilterLocationPolygonInput = {
  /** Polygon vertices in order (minimum 3 points) */
  vertices: Array<GeoPointInput>;
};

/** Filter input for numeric fields. */
export type FilterNumberInput = {
  /** The comparison type to use */
  type?: InputMaybe<FilterNumberType>;
  /** Values to compare against (count depends on type) */
  values?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/**
 * Numeric filter comparison types.
 * IN/NOT_IN support up to 30 values. BETWEEN requires exactly 2 values.
 * Comparison operators (GREATER_THAN, etc.) require exactly 1 value.
 */
export enum FilterNumberType {
  /** Match if field is between values[0] and values[1] inclusive */
  Between = 'BETWEEN',
  /** Match if field is greater than values[0] */
  GreaterThan = 'GREATER_THAN',
  /** Match if field is greater than or equal to values[0] */
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  /** Match if field equals any of the values */
  In = 'IN',
  /** Match if field is less than values[0] */
  LessThan = 'LESS_THAN',
  /** Match if field is less than or equal to values[0] */
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  /** Match if field does not equal any of the values */
  NotIn = 'NOT_IN'
}

/** Filter input for array fields (e.g., features, amenities). */
export type FilterStringArrayInput = {
  /** The comparison type to use */
  type?: InputMaybe<FilterStringArrayType>;
  /** Values to compare against */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Array filter comparison types for fields that contain multiple values.
 * Use CONTAINS_ANY for "has at least one of these" and CONTAINS_ALL for "has all of these".
 */
export enum FilterStringArrayType {
  /** Match if array contains ALL of the values (AND logic) */
  ContainsAll = 'CONTAINS_ALL',
  /** Match if array contains ANY of the values (OR logic) */
  ContainsAny = 'CONTAINS_ANY'
}

/** Filter input for string fields. */
export type FilterStringInput = {
  /** The comparison type to use */
  type?: InputMaybe<FilterStringType>;
  /** Values to compare against */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * String filter comparison types.
 * IN/NOT_IN perform exact matching. LIKE_ANY/LIKE_ALL support pattern matching.
 * All types support up to 30 values maximum.
 */
export enum FilterStringType {
  /** Match if field exactly equals any of the values (OR logic) */
  In = 'IN',
  /** Match if field contains ALL of the patterns (AND logic) */
  LikeAll = 'LIKE_ALL',
  /** Match if field contains ANY of the patterns (OR logic) */
  LikeAny = 'LIKE_ANY',
  /** Match if field does not equal any of the values */
  NotIn = 'NOT_IN'
}

/** Geographic coordinates for location-based features. */
export type GeoPoint = {
  __typename?: 'GeoPoint';
  /** Latitude in decimal degrees */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude in decimal degrees */
  lon?: Maybe<Scalars['Float']['output']>;
};

/** Input for geographic coordinates. */
export type GeoPointInput = {
  /** Latitude in decimal degrees */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude in decimal degrees */
  lon?: InputMaybe<Scalars['Float']['input']>;
};

/** An image associated with a listing or resort. */
export type Image = {
  __typename?: 'Image';
  /** Image caption/alt text */
  caption?: Maybe<Scalars['String']['output']>;
  /** Image category (e.g., exterior, bedroom) */
  category?: Maybe<Scalars['String']['output']>;
  /** External storage ID */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Image dimensions */
  size?: Maybe<ImageSize>;
  /** Image URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** Input for creating/updating an image. */
export type ImageInput = {
  /** Image caption/alt text */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Image category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** External storage ID */
  external_id?: InputMaybe<Scalars['String']['input']>;
  /** Image dimensions */
  size?: InputMaybe<ImageSizeInput>;
  /** Image URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Image dimensions in pixels. */
export type ImageSize = {
  __typename?: 'ImageSize';
  /** Height in pixels */
  height?: Maybe<Scalars['Int']['output']>;
  /** Width in pixels */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Input for image dimensions. */
export type ImageSizeInput = {
  /** Height in pixels */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Width in pixels */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for importing an image from an external URL. */
export type ImportImageInput = {
  /** Optional folder name to organize the imported image */
  folder_name?: InputMaybe<Scalars['String']['input']>;
  /** The image details to import */
  image: ImageInput;
  /** ID of the listing or resort this image relates to */
  related_to: Scalars['String']['input'];
};

/** Length-of-stay entry for a specific arrival date and guest count. */
export type Los = {
  __typename?: 'LOS';
  /** Arrival date */
  cal_date: Scalars['Date']['output'];
  /** Listing ID */
  lid?: Maybe<Scalars['String']['output']>;
  /** Maximum guests accommodated */
  max_guests: Scalars['Int']['output'];
  /** Available rates for different stay lengths */
  rates: Array<Rate>;
};

/**
 * Length-of-stay rate entry for a specific arrival date and guest count.
 * Contains rates for various stay lengths.
 */
export type LosInput = {
  /** The arrival date these rates apply to */
  cal_date: Scalars['Date']['input'];
  /** Maximum number of guests these rates accommodate */
  max_guests: Scalars['Int']['input'];
  /** Array of rates for different stay lengths */
  rates: Array<RateInput>;
};

/**
 * Arguments for querying length-of-stay rates.
 * Use to find available rates for specific dates, guest counts, and stay lengths.
 */
export type LosRatesArgsInput = {
  /** Specific arrival dates to check */
  arrivals?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Range of arrival dates to check */
  arrivals_range?: InputMaybe<DateRangeInput>;
  /** Number of guests (rates for this capacity or higher) */
  guests?: InputMaybe<Scalars['Int']['input']>;
  /** Filter to specific listing IDs */
  listing_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specific stay lengths (in nights) to retrieve rates for */
  nights?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A vacation rental listing representing a bookable property. */
export type Listing = {
  __typename?: 'Listing';
  /** Physical address */
  address?: Maybe<Address>;
  /** Unit size in square feet */
  area_sqft?: Maybe<Scalars['Int']['output']>;
  /** Average review rating */
  average_rating?: Maybe<Scalars['Float']['output']>;
  /** Number of bathrooms */
  bathrooms?: Maybe<Scalars['Float']['output']>;
  /** Number of bedrooms */
  bedrooms?: Maybe<Scalars['Int']['output']>;
  /** Total number of beds */
  beds?: Maybe<Scalars['Int']['output']>;
  /** Full HTML body content */
  body?: Maybe<Scalars['String']['output']>;
  /** Minimum days before check-in to book */
  booking_lead_time?: Maybe<Scalars['Int']['output']>;
  /** Building name within resort */
  building_name?: Maybe<Scalars['String']['output']>;
  /** Calendar availability (filtered by date range) */
  calendar_dates?: Maybe<Array<CalendarDate>>;
  /** Cancellation policy */
  cancellation_policy?: Maybe<CancellationPolicy>;
  /** Standard check-in time */
  check_in_time?: Maybe<Scalars['String']['output']>;
  /** Current guest check-out date */
  check_out?: Maybe<Scalars['Date']['output']>;
  /** Timestamp when created */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** Primary display image */
  default_image?: Maybe<Image>;
  /** Short text description */
  description?: Maybe<Scalars['String']['output']>;
  /** Date when rates become effective */
  effective_date?: Maybe<Scalars['Date']['output']>;
  /** Amenities and features */
  features?: Maybe<Array<FeatureDetail>>;
  /** Fee structure */
  fees?: Maybe<ListingFees>;
  /** Child listing IDs for hybrids */
  hybrid_child_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Listing images (use first param to limit) */
  images?: Maybe<Array<Image>>;
  /** Whether this is a group listing */
  is_group?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a hybrid listing */
  is_hybrid?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a timeshare */
  is_timeshare?: Maybe<Scalars['Boolean']['output']>;
  /** Listing availability status */
  listing_status?: Maybe<Scalars['String']['output']>;
  /** Locale identifier */
  locale_id?: Maybe<Scalars['String']['output']>;
  /** Locale name */
  locale_name?: Maybe<Scalars['String']['output']>;
  /** Geographic coordinates */
  location?: Maybe<GeoPoint>;
  /** Length-of-stay rates (filtered by input params) */
  los_rates?: Maybe<Array<Los>>;
  /** Property manager ID */
  manager_id?: Maybe<Scalars['String']['output']>;
  /** Property manager name */
  manager_name?: Maybe<Scalars['String']['output']>;
  /** Marketing content */
  marketing?: Maybe<ListingMarketingInfo>;
  /** Maximum guest capacity */
  max_guests?: Maybe<Scalars['Int']['output']>;
  /** Maximum pets allowed */
  max_pets?: Maybe<Scalars['Int']['output']>;
  /** Minimum nightly rate */
  minimum_rate?: Maybe<Scalars['Float']['output']>;
  /** Timestamp of last modification */
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  /** Internal name */
  name?: Maybe<Scalars['String']['output']>;
  /** Detailed name with unit specifics */
  name_detailed?: Maybe<Scalars['String']['output']>;
  /** Next available check-in date */
  next_check_in?: Maybe<Scalars['Date']['output']>;
  /** Rate range summary across all dates */
  rate_summary?: Maybe<ListingRateSummary>;
  /** Region identifier */
  region_id?: Maybe<Scalars['String']['output']>;
  /** Region name */
  region_name?: Maybe<Scalars['String']['output']>;
  /** Reservations for this listing (filtered by query params) */
  reservations?: Maybe<Array<Reservation>>;
  /** The resort this listing belongs to */
  resort?: Maybe<Resort>;
  /** Resort ID this listing belongs to */
  resort_id?: Maybe<Scalars['String']['output']>;
  /** Resort name */
  resort_name?: Maybe<Scalars['String']['output']>;
  /** Guest reviews */
  reviews?: Maybe<Array<ListingReview>>;
  /** Room details and bed configurations */
  rooms?: Maybe<Array<Room>>;
  /** Whether shown on public website */
  show_on_web?: Maybe<Scalars['Boolean']['output']>;
  /** URL-friendly slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Pipeline stage */
  stage?: Maybe<Scalars['String']['output']>;
  /** Current status */
  status?: Maybe<Scalars['String']['output']>;
  /** Property sub-type */
  sub_type?: Maybe<Scalars['String']['output']>;
  /** Tax registration ID */
  tax_id?: Maybe<Scalars['String']['output']>;
  /** Tax permit/license ID */
  tax_permit_id?: Maybe<Scalars['String']['output']>;
  /** Tax rate decimal */
  tax_rate?: Maybe<Scalars['Float']['output']>;
  /** Display title shown to guests */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether unit is in turnaround (between guests) */
  turnaround?: Maybe<Scalars['Boolean']['output']>;
  /** Property type (e.g., condo, villa) */
  type?: Maybe<Scalars['String']['output']>;
  /** External unit identifier */
  unit_id?: Maybe<Scalars['String']['output']>;
  /** Unit type classification */
  unit_type?: Maybe<Scalars['String']['output']>;
  /** View type (ocean, mountain, etc.) */
  unit_view?: Maybe<Scalars['String']['output']>;
  /** Full public URL for this listing, derived from brand configuration */
  url?: Maybe<Scalars['String']['output']>;
  /** Video URLs */
  video_url?: Maybe<Array<Scalars['String']['output']>>;
  /** Virtual tour URL */
  virtual_tour_url?: Maybe<Scalars['String']['output']>;
};


/** A vacation rental listing representing a bookable property. */
export type ListingCalendar_DatesArgs = {
  input?: InputMaybe<CalendarDatesArgsInput>;
};


/** A vacation rental listing representing a bookable property. */
export type ListingImagesArgs = {
  input?: InputMaybe<ArrayArgsInput>;
};


/** A vacation rental listing representing a bookable property. */
export type ListingLos_RatesArgs = {
  input?: InputMaybe<LosRatesArgsInput>;
};


/** A vacation rental listing representing a bookable property. */
export type ListingReservationsArgs = {
  input?: InputMaybe<ReservationsQueryInput>;
};

/**
 * Input for updating a listing's calendar availability.
 * Provide the complete calendar state - dates not included will be removed.
 */
export type ListingCalendarInput = {
  /** Array of calendar date entries */
  calendar: Array<CalendarDateInput>;
  /** The listing ID to update */
  id: Scalars['String']['input'];
};

/**
 * Fee structure configuration for a listing.
 * Used to calculate total fees based on stay parameters.
 */
export type ListingFeeDetails = {
  __typename?: 'ListingFeeDetails';
  /** Booking fee as a percentage of rent */
  booking_pct?: Maybe<Scalars['Float']['output']>;
  /** One-time cleaning fee */
  clean?: Maybe<Scalars['Float']['output']>;
  /** Per-night cleaning fee */
  cleaning_daily?: Maybe<Scalars['Float']['output']>;
  /** Damage protection/deposit fee */
  damage?: Maybe<Scalars['Float']['output']>;
  /** Per-night resort fee */
  resort_daily?: Maybe<Scalars['Float']['output']>;
  /** Flat resort fee */
  resort_flat?: Maybe<Scalars['Float']['output']>;
  /** Service fee as a percentage of rent */
  service_pct?: Maybe<Scalars['Float']['output']>;
};

/** Fee structure for a listing. */
export type ListingFees = {
  __typename?: 'ListingFees';
  /** Booking fee percentage */
  booking_pct?: Maybe<Scalars['Float']['output']>;
  /** One-time cleaning fee */
  cleaning?: Maybe<Scalars['Float']['output']>;
  /** Per-night cleaning fee */
  cleaning_daily?: Maybe<Scalars['Float']['output']>;
  /** Damage protection fee */
  damage?: Maybe<Scalars['Float']['output']>;
  /** Service fee percentage */
  service_pct?: Maybe<Scalars['Float']['output']>;
};

/** Input for listing fee structure. */
export type ListingFeesInput = {
  /** Booking fee percentage */
  booking_pct?: InputMaybe<Scalars['Float']['input']>;
  /** One-time cleaning fee */
  cleaning?: InputMaybe<Scalars['Float']['input']>;
  /** Per-night cleaning fee */
  cleaning_daily?: InputMaybe<Scalars['Float']['input']>;
  /** Damage protection fee */
  damage?: InputMaybe<Scalars['Float']['input']>;
  /** Service fee percentage */
  service_pct?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Input for creating or updating a listing.
 * Only include fields you want to set or update.
 */
export type ListingInput = {
  /** Physical address of the property */
  address?: InputMaybe<AddressInput>;
  /** Unit size in square feet */
  area_sqft?: InputMaybe<Scalars['Int']['input']>;
  /** Number of bathrooms (supports half baths as .5) */
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Number of bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of beds */
  beds?: InputMaybe<Scalars['Int']['input']>;
  /** Full HTML body content */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Minimum days before check-in to allow booking */
  booking_lead_time?: InputMaybe<Scalars['Int']['input']>;
  /** Building name within the resort */
  building_name?: InputMaybe<Scalars['String']['input']>;
  /** Cancellation policy details */
  cancellation_policy?: InputMaybe<CancellationPolicyInput>;
  /** Standard check-in time (e.g., "4:00 PM") */
  check_in_time?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when the listing was created */
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Short text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Date when rates become effective */
  effective_date?: InputMaybe<Scalars['Date']['input']>;
  /** Amenities and features */
  features?: InputMaybe<Array<FeatureDetailInput>>;
  /** Fee structure for the listing */
  fees?: InputMaybe<ListingFeesInput>;
  /** IDs of child listings for hybrid listings */
  hybrid_child_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Unique identifier for the listing (required) */
  id: Scalars['String']['input'];
  /** Array of images for the listing */
  images?: InputMaybe<Array<ImageInput>>;
  /** Whether this is a group listing */
  is_group?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a hybrid listing (multiple units) */
  is_hybrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a timeshare unit */
  is_timeshare?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the property lessor/owner */
  lessor_id?: InputMaybe<Scalars['String']['input']>;
  /** Name of the property lessor/owner */
  lessor_name?: InputMaybe<Scalars['String']['input']>;
  /** URL of the primary listing photo */
  listing_photo_url?: InputMaybe<Scalars['String']['input']>;
  /** Listing availability status */
  listing_status?: InputMaybe<Scalars['String']['input']>;
  /** Locale/neighborhood identifier */
  locale_id?: InputMaybe<Scalars['String']['input']>;
  /** Locale/neighborhood name */
  locale_name?: InputMaybe<Scalars['String']['input']>;
  /** Geographic coordinates */
  location?: InputMaybe<GeoPointInput>;
  /** Property manager ID (determines access control) */
  manager_id?: InputMaybe<Scalars['String']['input']>;
  /** Property manager name */
  manager_name?: InputMaybe<Scalars['String']['input']>;
  /** Marketing content and descriptions */
  marketing?: InputMaybe<ListingMarketingInfoInput>;
  /** Maximum guest capacity */
  max_guests?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of pets allowed */
  max_pets?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum nightly rate for the listing */
  minimum_rate?: InputMaybe<Scalars['Float']['input']>;
  /** Timestamp of last modification */
  modified_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Internal name for the listing */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Detailed name with unit specifics */
  name_detailed?: InputMaybe<Scalars['String']['input']>;
  /** Region identifier */
  region_id?: InputMaybe<Scalars['String']['input']>;
  /** Region name */
  region_name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the resort this listing belongs to */
  resort_id?: InputMaybe<Scalars['String']['input']>;
  /** Name of the resort this listing belongs to */
  resort_name?: InputMaybe<Scalars['String']['input']>;
  /** Guest reviews */
  reviews?: InputMaybe<Array<ListingReviewInput>>;
  /** Room details and bed configurations */
  rooms?: InputMaybe<Array<RoomInput>>;
  /** Whether to show on public website */
  show_on_web?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL-friendly slug for the listing */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Pipeline stage for internal workflow */
  stage?: InputMaybe<Scalars['String']['input']>;
  /** Current status of the listing */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Property sub-type for more specific categorization */
  sub_type?: InputMaybe<Scalars['String']['input']>;
  /** Tax registration ID */
  tax_id?: InputMaybe<Scalars['String']['input']>;
  /** Tax permit/license ID */
  tax_permit_id?: InputMaybe<Scalars['String']['input']>;
  /** Tax rate as a decimal */
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
  /** Display title shown to guests */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Property type (e.g., condo, villa, cabin) */
  type?: InputMaybe<Scalars['String']['input']>;
  /** External unit identifier */
  unit_id?: InputMaybe<Scalars['String']['input']>;
  /** Unit type classification */
  unit_type?: InputMaybe<Scalars['String']['input']>;
  /** View type (e.g., ocean, mountain, garden) */
  unit_view?: InputMaybe<Scalars['String']['input']>;
  /** URLs to videos */
  video_url?: InputMaybe<Array<Scalars['String']['input']>>;
  /** URL to virtual tour */
  virtual_tour_url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Length-of-stay rate data for a listing, including rate summaries.
 * Returned when querying listings with a stays filter.
 */
export type ListingLos = {
  __typename?: 'ListingLOS';
  /** Fee structure details for this listing */
  fee_details?: Maybe<ListingFeeDetails>;
  /** Listing ID */
  id: Scalars['String']['output'];
  /** Array of LOS entries by date and guest count */
  los: Array<Los>;
  /** Maximum total amount (rent + fees) across all available stays */
  max_amount?: Maybe<Scalars['Float']['output']>;
  /** Maximum discount percentage across all available stays */
  max_discount?: Maybe<Scalars['Float']['output']>;
  /** Minimum total amount (rent + fees) across all available stays */
  min_amount?: Maybe<Scalars['Float']['output']>;
  /** Minimum discount percentage across all available stays */
  min_discount?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input for updating length-of-stay rates for a listing.
 * Provide the complete rate data - dates not included will be removed.
 */
export type ListingLosInput = {
  /** The listing ID to update */
  id: Scalars['String']['input'];
  /** Array of LOS rate entries by arrival date and guest count */
  los: Array<LosInput>;
};

/** Marketing content for a listing. */
export type ListingMarketingInfo = {
  __typename?: 'ListingMarketingInfo';
  /** Marketing common name */
  common_name?: Maybe<Scalars['String']['output']>;
  /** Facility/amenities description */
  desc_facility?: Maybe<Scalars['String']['output']>;
  /** Location description */
  desc_location?: Maybe<Scalars['String']['output']>;
  /** Primary description */
  desc_primary?: Maybe<Scalars['String']['output']>;
  /** Transportation/directions description */
  desc_transport?: Maybe<Scalars['String']['output']>;
  /** First disclaimer shown after content */
  disclaimer_post_one?: Maybe<Scalars['String']['output']>;
  /** Second disclaimer shown after content */
  disclaimer_post_two?: Maybe<Scalars['String']['output']>;
  /** Disclaimer shown before content */
  disclaimer_pre?: Maybe<Scalars['String']['output']>;
  /** Primary marketing pitch/tagline */
  primary_pitch?: Maybe<Scalars['String']['output']>;
  /** Display priority for sorting */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Short display name */
  short_name?: Maybe<Scalars['String']['output']>;
};

/** Input for listing marketing content. */
export type ListingMarketingInfoInput = {
  /** Marketing common name */
  common_name?: InputMaybe<Scalars['String']['input']>;
  /** Facility description */
  desc_facility?: InputMaybe<Scalars['String']['input']>;
  /** Location description */
  desc_location?: InputMaybe<Scalars['String']['input']>;
  /** Primary description */
  desc_primary?: InputMaybe<Scalars['String']['input']>;
  /** Transportation description */
  desc_transport?: InputMaybe<Scalars['String']['input']>;
  /** Post disclaimer one */
  disclaimer_post_one?: InputMaybe<Scalars['String']['input']>;
  /** Post disclaimer two */
  disclaimer_post_two?: InputMaybe<Scalars['String']['input']>;
  /** Pre disclaimer */
  disclaimer_pre?: InputMaybe<Scalars['String']['input']>;
  /** Primary marketing pitch */
  primary_pitch?: InputMaybe<Scalars['String']['input']>;
  /** Display priority */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Short display name */
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * ListingRateSummary is calculated from the LOS rates for a listing. It provides a summary of the
 * minimum and maximum total, rent, and fees among all possible future stays for a listing.
 */
export type ListingRateSummary = {
  __typename?: 'ListingRateSummary';
  /** The maximum total fees before taxes for a future stay at the listing. */
  max_fees_nt?: Maybe<Scalars['Float']['output']>;
  /** The maximum nightly rent rate, before taxes and fees, for a future stay at the listing. */
  max_rent_nt?: Maybe<Scalars['Float']['output']>;
  /** The maximum total nightly rate, including all mandatory fees and before taxes, for a future stay at the listing. */
  max_total_nt?: Maybe<Scalars['Float']['output']>;
  /** The minimum total fees before taxes for a future stay at the listing. */
  min_fees_nt?: Maybe<Scalars['Float']['output']>;
  /** The minimum nightly rent rate, before taxes and fees, for a future stay at the listing. */
  min_rent_nt?: Maybe<Scalars['Float']['output']>;
  /** The minimum total nightly rate, including all mandatory fees and before taxes, for a future stay at the listing. */
  min_total_nt?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input for bulk updating reservations associated with a specific listing.
 * Used by the updateListingsReservations mutation.
 */
export type ListingReservationInput = {
  /** The listing ID to update reservations for */
  id: Scalars['String']['input'];
  /** Array of reservations to create or update for this listing */
  reservations: Array<InputMaybe<ReservationInput>>;
};

/** Guest review for a listing. */
export type ListingReview = {
  __typename?: 'ListingReview';
  /** Rating score (typically 1-5) */
  rating: Scalars['Float']['output'];
  /** Property manager's response to the review */
  review_response?: Maybe<Scalars['String']['output']>;
  /** Reviewer name or identifier */
  reviewer?: Maybe<Scalars['String']['output']>;
  /** Source platform of the review (e.g., vrbo, airbnb) */
  source?: Maybe<Scalars['String']['output']>;
  /** Date of the stay being reviewed */
  stay_date?: Maybe<Scalars['Date']['output']>;
  /** Date the review was submitted */
  submitted_date?: Maybe<Scalars['Date']['output']>;
  /** Review text content */
  text: Scalars['String']['output'];
  /** Review title/headline */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input for creating/updating a guest review. */
export type ListingReviewInput = {
  /** Rating score (typically 1-5) */
  rating: Scalars['Float']['input'];
  /** Property manager's response to the review */
  review_response?: InputMaybe<Scalars['String']['input']>;
  /** Reviewer name or identifier */
  reviewer?: InputMaybe<Scalars['String']['input']>;
  /** Date of the stay being reviewed */
  stay_date?: InputMaybe<Scalars['Date']['input']>;
  /** Date the review was submitted */
  submitted_date?: InputMaybe<Scalars['Date']['input']>;
  /** Review text content */
  text: Scalars['String']['input'];
  /** Review title/headline */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Available fields for sorting listing results. */
export enum ListingSortField {
  /** Sort by number of bedrooms */
  Bedrooms = 'BEDROOMS',
  /** Sort by effective date */
  EffectiveDate = 'EFFECTIVE_DATE',
  /** Sort by maximum guest capacity */
  MaxGuests = 'MAX_GUESTS',
  /** Sort by price (requires stays filter) */
  Price = 'PRICE',
  /** Sort alphabetically by title */
  Title = 'TITLE'
}

/** Sorting options for listing queries. */
export type ListingSortInput = {
  /** The field to sort by */
  field?: InputMaybe<ListingSortField>;
  /** Sort direction (ASC or DESC) */
  order?: InputMaybe<SortOrder>;
};

/** Per-listing tracking URLs for impression and click analytics. */
export type ListingTracking = {
  __typename?: 'ListingTracking';
  /** URL to fire for click tracking */
  click_tracker_url?: Maybe<Scalars['String']['output']>;
  /** URL to fire for impression tracking */
  impression_tracker_url?: Maybe<Scalars['String']['output']>;
  /** The listing ID this tracking data belongs to */
  listing_id: Scalars['String']['output'];
};

/**
 * Faceted search results showing available filter values and counts.
 * Use these to build dynamic filter UIs that show users what options are available.
 */
export type ListingsFacets = {
  __typename?: 'ListingsFacets';
  /** Available bathroom counts with listing counts */
  bathrooms?: Maybe<Array<FacetNumber>>;
  /** Available bedroom counts with listing counts */
  bedrooms?: Maybe<Array<FacetNumber>>;
  /** Available bed counts with listing counts */
  beds?: Maybe<Array<FacetNumber>>;
  /** Available features/amenities with listing counts */
  features?: Maybe<Array<FacetFeature>>;
  /** Available locales/neighborhoods with listing counts */
  locales?: Maybe<Array<FacetString>>;
  /** Available max guest capacities with listing counts */
  max_guests?: Maybe<Array<FacetNumber>>;
  /** Available max pet values with listing counts */
  max_pets?: Maybe<Array<FacetNumber>>;
  /** Price range buckets with listing counts */
  price_buckets?: Maybe<Array<FacetNumber>>;
  /** Maximum price across all matching listings */
  price_max?: Maybe<Scalars['Float']['output']>;
  /** Minimum price across all matching listings */
  price_min?: Maybe<Scalars['Float']['output']>;
  /** Available regions with listing counts */
  regions?: Maybe<Array<FacetString>>;
  /** Available resorts with listing counts */
  resorts?: Maybe<Array<FacetResort>>;
  /** Available unit types with listing counts */
  unit_types?: Maybe<Array<FacetString>>;
  /** Available unit views with listing counts */
  unit_views?: Maybe<Array<FacetString>>;
};

/**
 * Request facet aggregations for building filter UIs.
 * Set a field to true to include that facet in the response.
 * Facets show available filter values and how many listings match each value.
 */
export type ListingsFacetsInput = {
  /** Get counts by bathroom count */
  bathrooms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by bedroom count */
  bedrooms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by bed count */
  beds?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by feature/amenity */
  features?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by locale/neighborhood */
  locales?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by max guest capacity */
  max_guests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by max pets allowed */
  max_pets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by price ranges */
  price_buckets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get the maximum price across all results */
  price_max?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get the minimum price across all results */
  price_min?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by region */
  regions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by resort */
  resorts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by unit type */
  unit_types?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get counts by unit view type */
  unit_views?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filter criteria for listing queries. All filters are combined with AND logic.
 * Use these filters to narrow down search results by property attributes,
 * location, availability, and pricing.
 */
export type ListingsFiltersInput = {
  /** Filter by unit square footage */
  area_sqft?: InputMaybe<FilterNumberInput>;
  /** Filter by number of bathrooms */
  bathrooms?: InputMaybe<FilterNumberInput>;
  /** Filter by number of bedrooms */
  bedrooms?: InputMaybe<FilterNumberInput>;
  /** Filter by total number of beds */
  beds?: InputMaybe<FilterNumberInput>;
  /** Filter by building name within a resort */
  building_names?: InputMaybe<FilterStringInput>;
  /** Filter by marketing common name */
  common_name?: InputMaybe<FilterStringInput>;
  /** Filter by effective date for rate calculations */
  effective_date?: InputMaybe<FilterDateInput>;
  /** Filter by amenities/features (e.g., pool, wifi, pet-friendly) */
  features?: InputMaybe<FilterStringArrayInput>;
  /** Filter for group listings only */
  is_group?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for hybrid listings (multiple units sold together) */
  is_hybrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for timeshare units */
  is_timeshare?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by specific listing IDs */
  listing_ids?: InputMaybe<FilterStringInput>;
  /** Filter by listing status (e.g., active, inactive) */
  listing_status?: InputMaybe<FilterStringInput>;
  /** Filter by locale/neighborhood name */
  locale_name?: InputMaybe<FilterStringInput>;
  /** Filter by distance from a geographic point */
  location_distance?: InputMaybe<FilterLocationDistanceInput>;
  /** Filter by location within a polygon boundary */
  location_polygon?: InputMaybe<FilterLocationPolygonInput>;
  /** Filter by property manager IDs */
  manager_ids?: InputMaybe<FilterStringInput>;
  /** Filter by maximum total price for a stay */
  max_amount?: InputMaybe<FilterNumberInput>;
  /** Filter by maximum guest capacity */
  max_guests?: InputMaybe<FilterNumberInput>;
  /** Filter by maximum pets allowed */
  max_pets?: InputMaybe<FilterNumberInput>;
  /** Filter by minimum total price for a stay */
  min_amount?: InputMaybe<FilterNumberInput>;
  /** Filter for pet-friendly listings */
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by region name */
  region_name?: InputMaybe<FilterStringInput>;
  /** Filter by resort IDs */
  resort_ids?: InputMaybe<FilterStringInput>;
  /** Filter by resort name */
  resort_name?: InputMaybe<FilterStringInput>;
  /** Filter by web visibility status */
  show_on_web?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by URL slug */
  slug?: InputMaybe<FilterStringInput>;
  /** Filter by availability and rates for specific stay parameters */
  stays?: InputMaybe<LosRatesArgsInput>;
  /** Filter by property type */
  type?: InputMaybe<FilterStringInput>;
  /** Filter by unit type (e.g., condo, villa, cabin) */
  unit_types?: InputMaybe<FilterStringInput>;
  /** Filter by unit view type (e.g., ocean, mountain, garden) */
  unit_views?: InputMaybe<FilterStringInput>;
};

/**
 * Input for querying listings with filtering, sorting, pagination, and facets.
 * All parameters are optional - omit to use defaults.
 */
export type ListingsQueryInput = {
  /** Optional end-user context. When present, enables personalized ranking. */
  end_user?: InputMaybe<EndUserContextInput>;
  /** Request facet counts for filter UI construction */
  facets?: InputMaybe<ListingsFacetsInput>;
  /** Filter criteria to narrow results */
  filters?: InputMaybe<ListingsFiltersInput>;
  /** Pagination controls */
  page?: InputMaybe<PageInput>;
  /** Sort criteria applied in order. First sort is primary. */
  sorts?: InputMaybe<Array<ListingSortInput>>;
};

/** Response from a listings query, including pagination and facets. */
export type ListingsQueryOutput = {
  __typename?: 'ListingsQueryOutput';
  /** Personalization cohort identifier (present when personalized) */
  cohort?: Maybe<Scalars['String']['output']>;
  /** Aggregated facet counts for building filter UIs */
  facets?: Maybe<ListingsFacets>;
  /** Array of listings matching the query criteria */
  listings: Array<Listing>;
  /** Pagination information for the result set */
  page?: Maybe<PageOutput>;
  /** Length-of-stay rates for the returned listings when filtering by stays */
  rates?: Maybe<Array<ListingLos>>;
  /** Per-listing tracking URLs for impression/click analytics (present when personalized) */
  tracking?: Maybe<Array<ListingTracking>>;
};

/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new announcement. */
  createAnnouncement: ObjectMutationResponse;
  /**
   * Create or update an API client. If a client with the given ID exists,
   * it will be updated; otherwise, a new client is created. When providing
   * a password, it will be hashed using bcrypt before storage.
   */
  createOrUpdateAPIClient: ObjectMutationResponse;
  /** Delete an announcement by ID. */
  deleteAnnouncement: ObjectMutationResponse;
  /** Delete one or more announcements by ID/UUID. */
  deleteAnnouncements: Array<ObjectMutationResponse>;
  /** Delete a brand configuration by ID. */
  deleteBrandConfig: ObjectMutationResponse;
  /**
   * Delete one or more listings by ID. This permanently removes the listings
   * and all associated data including calendar and rate information.
   */
  deleteListings: Array<ObjectMutationResponse>;
  /** Delete one or more reservations by ID. This permanently removes the reservations. */
  deleteReservations: Array<ObjectMutationResponse>;
  /**
   * Delete one or more resorts by ID. This permanently removes the resorts.
   * Note: Listings associated with deleted resorts are not automatically removed.
   */
  deleteResorts: Array<ObjectMutationResponse>;
  /**
   * Import an image from an external URL into the system's image storage.
   * The image is downloaded, stored, and associated with the specified resource.
   */
  importImage?: Maybe<Image>;
  /**
   * Register an end user's browsing context to pre-warm personalized rankings.
   * Typically called fire-and-forget on page load.
   */
  registerEndUser: RegisterEndUserOutput;
  /** Update an existing announcement. */
  updateAnnouncement: ObjectMutationResponse;
  /**
   * Create or update one or more announcements. If an announcement with the
   * given UUID exists, it will be updated; otherwise, a new announcement is created.
   */
  updateAnnouncements: Array<ObjectMutationResponse>;
  /**
   * Create or update a brand configuration. If a brand config with the given ID
   * exists, it will be updated; otherwise, a new brand config is created.
   */
  updateBrandConfig: ObjectMutationResponse;
  /**
   * Rebuild the search index for listings. Use this after bulk updates to
   * ensure search results reflect the latest data. Can be scoped to specific
   * managers using the manager_ids filter.
   */
  updateListingIndexes: UpdateListingIndexesResponse;
  /**
   * Create or update one or more listings. If a listing with the given ID exists,
   * it will be updated; otherwise, a new listing is created. Returns a response
   * for each input indicating success or failure.
   */
  updateListings: Array<ObjectMutationResponse>;
  /**
   * Update calendar availability for listings. Each calendar entry defines
   * availability, check-in/check-out rules, and minimum stay requirements
   * for a specific date. Existing dates not included in the input will be removed.
   */
  updateListingsCalendars: Array<ObjectMutationResponse>;
  /**
   * Update length-of-stay (LOS) pricing rates for listings. Rates define the
   * nightly pricing for different arrival dates, stay lengths, and guest counts.
   * Existing rates not included in the input will be removed.
   */
  updateListingsLOS: Array<ObjectMutationResponse>;
  /**
   * Update reservations for specific listings. Allows bulk update of reservation
   * data associated with listings.
   */
  updateListingsReservations: Array<ObjectMutationResponse>;
  /**
   * Create or update one or more reservations. If a reservation with the given ID
   * exists, it will be updated; otherwise, a new reservation is created.
   */
  updateReservations: Array<ObjectMutationResponse>;
  /**
   * Create or update one or more resorts. If a resort with the given ID exists,
   * it will be updated; otherwise, a new resort is created.
   */
  updateResorts: Array<ObjectMutationResponse>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationCreateAnnouncementArgs = {
  input: AnnouncementInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationCreateOrUpdateApiClientArgs = {
  input: ApiClientInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationDeleteAnnouncementArgs = {
  id: Scalars['String']['input'];
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationDeleteAnnouncementsArgs = {
  ids: Array<Scalars['String']['input']>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationDeleteBrandConfigArgs = {
  id: Scalars['String']['input'];
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationDeleteListingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationDeleteReservationsArgs = {
  ids: Array<Scalars['String']['input']>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationDeleteResortsArgs = {
  ids: Array<Scalars['String']['input']>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationImportImageArgs = {
  input: ImportImageInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationRegisterEndUserArgs = {
  input: EndUserContextInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateAnnouncementArgs = {
  input: AnnouncementInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateAnnouncementsArgs = {
  inputs: Array<AnnouncementInput>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateBrandConfigArgs = {
  input: BrandConfigInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateListingIndexesArgs = {
  input: UpdateListingIndexesInput;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateListingsArgs = {
  inputs: Array<ListingInput>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateListingsCalendarsArgs = {
  inputs: Array<ListingCalendarInput>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateListingsLosArgs = {
  inputs: Array<ListingLosInput>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateListingsReservationsArgs = {
  inputs: Array<ListingReservationInput>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateReservationsArgs = {
  inputs: Array<ReservationInput>;
};


/**
 * Mutation operations for creating, updating, and deleting listings and resorts.
 * All mutations are scoped to your authorized manager_ids. Attempting to modify
 * resources outside your authorization will return an error response.
 */
export type MutationUpdateResortsArgs = {
  inputs: Array<ResortInput>;
};

/**
 * Response returned for each item in a batch mutation operation.
 * Check the success field to determine if the operation succeeded.
 */
export type ObjectMutationResponse = {
  __typename?: 'ObjectMutationResponse';
  /** The ID of the resource that was operated on */
  id: Scalars['String']['output'];
  /** Human-readable message with details (especially on failure) */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Pagination input for controlling result set size and offset. */
export type PageInput = {
  /** Number of results to skip for pagination (default: 0) */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of results to return (default: 10) */
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Pagination metadata returned with query results. */
export type PageOutput = {
  __typename?: 'PageOutput';
  /** Offset from the start of the result set */
  offset?: Maybe<Scalars['Int']['output']>;
  /** Number of results returned in this page */
  size?: Maybe<Scalars['Int']['output']>;
  /** Total number of results matching the query (before pagination) */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Ranking context for personalization. */
export enum PersonalizationUsage {
  /** Location or curated collection pages */
  Collection = 'COLLECTION',
  /** Main search / browse pages */
  Search = 'SEARCH'
}

/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type Query = {
  __typename?: 'Query';
  /**
   * Fetch a single announcement by its unique ID.
   * Returns null if not found or you are not authorized to view it.
   */
  announcement?: Maybe<Announcement>;
  /**
   * Search and retrieve announcements with optional filtering and pagination.
   * Returns a list of announcements (e.g. banner content, CTAs).
   */
  announcements: AnnouncementsQueryOutput;
  /**
   * Fetch a brand configuration by its unique ID.
   * Returns null if not found or you are not authorized to view it.
   */
  brandConfig?: Maybe<BrandConfig>;
  /** Fetch all brand configurations accessible to you. */
  brandConfigs: Array<BrandConfig>;
  /**
   * Get the dimensions of an image from its URL.
   * Useful for layout calculations before loading images.
   */
  imageSize?: Maybe<ImageSize>;
  /**
   * Fetch a single listing by its unique ID.
   * Returns null if the listing is not found or you are not authorized to view it.
   */
  listing?: Maybe<Listing>;
  /**
   * Fetch a single listing by its URL slug.
   * Returns null if the listing is not found or you are not authorized to view it.
   */
  listingBySlug?: Maybe<Listing>;
  /**
   * Search and retrieve listings with optional filtering, sorting, and pagination.
   * Supports faceted search to get aggregated counts for filter options.
   * Returns a paginated list of listings matching the criteria.
   */
  listings: ListingsQueryOutput;
  /**
   * Get personalized listing recommendations for a page context.
   * Returns listings ranked by relevance to the end user.
   */
  recommendedListings: RecommendedListingsOutput;
  /**
   * Fetch a single reservation by its unique ID.
   * Returns null if the reservation is not found or you are not authorized to view it.
   */
  reservation?: Maybe<Reservation>;
  /**
   * Search and retrieve reservations with optional filtering, sorting, and pagination.
   * Returns a list of reservations matching the criteria.
   */
  reservations: ReservationsQueryOutput;
  /**
   * Fetch a single resort by its unique ID.
   * Returns null if the resort is not found or you are not authorized to view it.
   */
  resort?: Maybe<Resort>;
  /**
   * Fetch a single resort by its URL slug.
   * Returns null if the resort is not found or you are not authorized to view it.
   */
  resortBySlug?: Maybe<Resort>;
  /**
   * Search and retrieve resorts with optional filtering, sorting, and pagination.
   * Returns a list of resorts matching the criteria.
   */
  resorts: ResortsQueryOutput;
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryAnnouncementArgs = {
  id: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryAnnouncementsArgs = {
  input?: InputMaybe<AnnouncementsQueryInput>;
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryBrandConfigArgs = {
  id: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryImageSizeArgs = {
  url: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryListingArgs = {
  id: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryListingBySlugArgs = {
  manager_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryListingsArgs = {
  input?: InputMaybe<ListingsQueryInput>;
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryRecommendedListingsArgs = {
  input: RecommendedListingsInput;
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryReservationArgs = {
  id: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryReservationsArgs = {
  input?: InputMaybe<ReservationsQueryInput>;
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryResortArgs = {
  id: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryResortBySlugArgs = {
  manager_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
};


/**
 * Query operations for retrieving listings and resorts.
 * All queries automatically filter results based on your authorized access.
 */
export type QueryResortsArgs = {
  input?: InputMaybe<ResortsQueryInput>;
};

/** Rate for a specific stay length, including calculated fees. */
export type Rate = {
  __typename?: 'Rate';
  /** Base rent amount for the stay (before fees) */
  amount: Scalars['Float']['output'];
  /** Discount percentage applied, if any */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Calculated fee breakdown for this rate */
  fee_details?: Maybe<RateFeeDetails>;
  /** Associated listing IDs (for hybrid listings) */
  lids?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of nights for this rate */
  nights: Scalars['Int']['output'];
};

/**
 * Calculated fee breakdown for a specific rate/stay.
 * All amounts are in the listing's currency.
 */
export type RateFeeDetails = {
  __typename?: 'RateFeeDetails';
  /** Booking fee amount */
  booking?: Maybe<Scalars['Float']['output']>;
  /** Cleaning fee amount */
  clean?: Maybe<Scalars['Float']['output']>;
  /** Daily cleaning fee total */
  cleaning_daily?: Maybe<Scalars['Float']['output']>;
  /** Damage protection fee */
  damage?: Maybe<Scalars['Float']['output']>;
  /** Resort fee total */
  resort?: Maybe<Scalars['Float']['output']>;
  /** Service fee amount */
  service?: Maybe<Scalars['Float']['output']>;
  /** The fee types that are collected at the property during the stay */
  stay_collected_fees?: Maybe<Array<FeeType>>;
  /** Of the fee total, the amount that is collected at the property during the stay */
  stay_collected_total?: Maybe<Scalars['Float']['output']>;
  /** Total of all fees */
  total?: Maybe<Scalars['Float']['output']>;
};

/** Input for creating/updating a rate entry. */
export type RateInput = {
  /** Base rent amount for the stay */
  amount: Scalars['Float']['input'];
  /** Discount percentage to apply */
  discount?: InputMaybe<Scalars['Float']['input']>;
  /** Associated listing IDs (for hybrid listings) */
  lids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Number of nights for this rate */
  nights: Scalars['Int']['input'];
};

/** Page type context for recommendation requests. */
export enum RecommendationPageType {
  /** Home page recommendations */
  Home = 'HOME',
  /** Property page recommendations (related/similar) */
  Property = 'PROPERTY'
}

/** Input for querying personalized recommendations. */
export type RecommendedListingsInput = {
  /** End-user context (required for recommendations) */
  end_user: EndUserContextInput;
  /** Maximum number of recommendations to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Listing ID for property-page recommendations (related items) */
  listing_id?: InputMaybe<Scalars['String']['input']>;
  /** Page context for recommendation logic */
  page_type: RecommendationPageType;
};

/** Response from a recommendedListings query. */
export type RecommendedListingsOutput = {
  __typename?: 'RecommendedListingsOutput';
  /** Personalization cohort identifier */
  cohort?: Maybe<Scalars['String']['output']>;
  /** Recommended listings in ranked order */
  listings: Array<Listing>;
  /** Per-listing tracking URLs for analytics */
  tracking?: Maybe<Array<ListingTracking>>;
};

/** Response from the registerEndUser mutation. */
export type RegisterEndUserOutput = {
  __typename?: 'RegisterEndUserOutput';
  /** Number of ranked listings cached for this user */
  cached_count?: Maybe<Scalars['Int']['output']>;
  /** Personalization cohort identifier */
  cohort?: Maybe<Scalars['String']['output']>;
  /** Whether the registration succeeded */
  success: Scalars['Boolean']['output'];
};

/**
 * A reservation for a listing, representing a guest booking or owner block.
 * Contains check-in/check-out dates, guest count, and booking status information.
 */
export type Reservation = {
  __typename?: 'Reservation';
  /** Timestamp when the reservation was cancelled (if cancelled) */
  cancelled_date?: Maybe<Scalars['DateTime']['output']>;
  /** Check-in date (arrival date) */
  check_in: Scalars['Date']['output'];
  /** Exact check-in time with timezone */
  check_in_time: Scalars['DateTime']['output'];
  /** Check-out date (departure date) */
  check_out: Scalars['Date']['output'];
  /** Exact check-out time with timezone */
  check_out_time: Scalars['DateTime']['output'];
  /** Timestamp when the reservation was confirmed (if confirmed) */
  confirmed_date?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the reservation was created */
  created_date: Scalars['DateTime']['output'];
  /** Number of guests for this reservation */
  guests: Scalars['Int']['output'];
  /** Guests associated with this reservation */
  guests_details?: Maybe<Array<ReservationGuest>>;
  /** Unique identifier for the reservation */
  id: Scalars['String']['output'];
  /** The listing associated with this reservation */
  listing: Listing;
  /** ID of the listing this reservation is for */
  listing_id: Scalars['String']['output'];
  /** ID of the property manager who owns this reservation */
  manager_id: Scalars['String']['output'];
  /** Timestamp of the last modification */
  modified_date: Scalars['DateTime']['output'];
  /** Number of nights for the stay */
  nights: Scalars['Int']['output'];
  /** Number of pets for this reservation */
  pets: Scalars['Int']['output'];
  /** Total rental amount for the reservation */
  rental_amount?: Maybe<Scalars['Float']['output']>;
  /** Current status of the reservation */
  status: ReservationStatus;
  /** Type of reservation (guest, owner, maintenance, etc.) */
  type: ReservationType;
};

/** A guest associated with a reservation. */
export type ReservationGuest = {
  __typename?: 'ReservationGuest';
  /** Whether this guest is the primary host for the reservation */
  host: Scalars['Boolean']['output'];
  /** Unique identifier for the guest */
  id: Scalars['String']['output'];
};

/** Input for creating or updating a reservation guest. */
export type ReservationGuestInput = {
  /** Whether this guest is the primary host for the reservation */
  host: Scalars['Boolean']['input'];
  /** Unique identifier for the guest */
  id: Scalars['String']['input'];
};

/**
 * Input for creating or updating a reservation.
 * All required fields must be provided when creating a new reservation.
 */
export type ReservationInput = {
  /** Timestamp when the reservation was cancelled (optional) */
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Check-in date (arrival date) */
  check_in: Scalars['Date']['input'];
  /** Exact check-in time with timezone */
  check_in_time: Scalars['DateTime']['input'];
  /** Check-out date (departure date) */
  check_out: Scalars['Date']['input'];
  /** Exact check-out time with timezone */
  check_out_time: Scalars['DateTime']['input'];
  /** Timestamp when the reservation was confirmed (optional) */
  confirmed_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Timestamp when the reservation was created */
  created_date: Scalars['DateTime']['input'];
  /** Number of guests for this reservation */
  guests: Scalars['Int']['input'];
  /** Guests associated with this reservation */
  guests_details?: InputMaybe<Array<ReservationGuestInput>>;
  /** Unique identifier for the reservation (required) */
  id: Scalars['String']['input'];
  /** ID of the listing this reservation is for */
  listing_id: Scalars['String']['input'];
  /** ID of the property manager who owns this reservation */
  manager_id: Scalars['String']['input'];
  /** Timestamp of the last modification */
  modified_date: Scalars['DateTime']['input'];
  /** Number of nights for the stay */
  nights: Scalars['Int']['input'];
  /** Number of pets for this reservation */
  pets: Scalars['Int']['input'];
  /** Total rental amount for the reservation */
  rental_amount?: InputMaybe<Scalars['Float']['input']>;
  /** Current status of the reservation */
  status: ReservationStatus;
  /** Type of reservation (guest, owner, maintenance, etc.) */
  type: ReservationType;
};

/** Available fields for sorting reservation results. */
export enum ReservationSortField {
  /** Sort by cancelled date */
  CancelledDate = 'CANCELLED_DATE',
  /** Sort by check-in date */
  CheckIn = 'CHECK_IN',
  /** Sort by check-out date */
  CheckOut = 'CHECK_OUT',
  /** Sort by confirmed date */
  ConfirmedDate = 'CONFIRMED_DATE',
  /** Sort by creation date */
  CreatedDate = 'CREATED_DATE',
  /** Sort by modification date */
  ModifiedDate = 'MODIFIED_DATE'
}

/** Sorting options for reservation queries. */
export type ReservationSortInput = {
  /** The field to sort by */
  field?: InputMaybe<ReservationSortField>;
  /** Sort direction (ASC or DESC) */
  order?: InputMaybe<SortOrder>;
};

/** Current status of a reservation. */
export enum ReservationStatus {
  /** Reservation has been cancelled */
  Cancelled = 'CANCELLED',
  /** Reservation is confirmed and active */
  Confirmed = 'CONFIRMED',
  /** Reservation is pending confirmation */
  Pending = 'PENDING',
  /** Initial quote stage, not yet confirmed */
  Quote = 'QUOTE'
}

/** Type of reservation indicating the purpose of the booking. */
export enum ReservationType {
  /** Standard guest booking */
  Guest = 'GUEST',
  /** Property blocked for maintenance */
  Maintenance = 'MAINTENANCE',
  /** Other reservation type */
  Other = 'OTHER',
  /** Owner using their own property */
  Owner = 'OWNER',
  /** Owner's guest using the property */
  OwnerGuest = 'OWNER_GUEST'
}

/** Filter criteria for reservation queries. All filters are combined with AND logic. */
export type ReservationsFiltersInput = {
  /** Filter by cancelled datetime */
  cancelled_date?: InputMaybe<FilterDateTimeInput>;
  /** Filter by check-in date */
  check_in?: InputMaybe<FilterDateInput>;
  /** Filter by check-out date */
  check_out?: InputMaybe<FilterDateInput>;
  /** Filter by confirmed datetime */
  confirmed_date?: InputMaybe<FilterDateTimeInput>;
  /** Filter by creation datetime */
  created_date?: InputMaybe<FilterDateTimeInput>;
  /** Filter by specific listing IDs */
  listing_ids?: InputMaybe<FilterStringInput>;
  /** Filter by property manager IDs */
  manager_ids?: InputMaybe<FilterStringInput>;
  /** Filter by modification datetime */
  modified_date?: InputMaybe<FilterDateTimeInput>;
  /** Filter by reservation status */
  statuses?: InputMaybe<FilterStringInput>;
  /** Filter by reservation type */
  types?: InputMaybe<FilterStringInput>;
};

/** Input for querying reservations with filtering, sorting, and pagination. */
export type ReservationsQueryInput = {
  /** Filter criteria to narrow results */
  filters?: InputMaybe<ReservationsFiltersInput>;
  /** Pagination controls */
  page?: InputMaybe<PageInput>;
  /** Sort criteria applied in order */
  sorts?: InputMaybe<Array<ReservationSortInput>>;
};

/** Response from a reservations query, including pagination. */
export type ReservationsQueryOutput = {
  __typename?: 'ReservationsQueryOutput';
  /** Pagination information for the result set */
  page?: Maybe<PageOutput>;
  /** Array of reservations matching the query criteria */
  reservations: Array<Reservation>;
};

/** A resort or property group containing multiple listings. */
export type Resort = {
  __typename?: 'Resort';
  /** Physical address */
  address?: Maybe<Address>;
  /** Full HTML body content */
  body?: Maybe<Scalars['String']['output']>;
  /** Timestamp when created */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** Short description */
  description?: Maybe<Scalars['String']['output']>;
  /** Resort amenities and features */
  features?: Maybe<Array<FeatureDetail>>;
  /** Fee structure */
  fees?: Maybe<ResortFees>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Resort images */
  images?: Maybe<Array<Image>>;
  /** Query listings at this resort */
  listings: ListingsQueryOutput;
  /** Count of listings at this resort */
  listings_count?: Maybe<Scalars['Int']['output']>;
  /** Locale identifier */
  locale_id?: Maybe<Scalars['String']['output']>;
  /** Locale name */
  locale_name?: Maybe<Scalars['String']['output']>;
  /** Geographic coordinates */
  location?: Maybe<GeoPoint>;
  /** Property manager ID */
  manager_id?: Maybe<Scalars['String']['output']>;
  /** Property manager name */
  manager_name?: Maybe<Scalars['String']['output']>;
  /** Marketing content */
  marketing?: Maybe<ResortMarketingInfo>;
  /** Timestamp of last modification */
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  /** Internal name */
  name?: Maybe<Scalars['String']['output']>;
  /** Region identifier */
  region_id?: Maybe<Scalars['String']['output']>;
  /** Region name */
  region_name?: Maybe<Scalars['String']['output']>;
  /** Whether shown on public website */
  show_on_web?: Maybe<Scalars['Boolean']['output']>;
  /** URL-friendly slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Current status */
  status?: Maybe<Scalars['String']['output']>;
  /** Resort sub-type */
  sub_type?: Maybe<Scalars['String']['output']>;
  /** Tax registration ID */
  tax_id?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title?: Maybe<Scalars['String']['output']>;
  /** Resort type */
  type?: Maybe<Scalars['String']['output']>;
  /** Full public URL for this resort, derived from brand configuration */
  url?: Maybe<Scalars['String']['output']>;
  /** Video URLs */
  video_url?: Maybe<Array<Scalars['String']['output']>>;
};


/** A resort or property group containing multiple listings. */
export type ResortImagesArgs = {
  input?: InputMaybe<ArrayArgsInput>;
};


/** A resort or property group containing multiple listings. */
export type ResortListingsArgs = {
  input?: InputMaybe<ListingsQueryInput>;
};


/** A resort or property group containing multiple listings. */
export type ResortListings_CountArgs = {
  show_on_web?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fee structure for a resort. */
export type ResortFees = {
  __typename?: 'ResortFees';
  /** Parking fee */
  parking?: Maybe<Scalars['Float']['output']>;
  /** Resort fee amount */
  resort?: Maybe<Scalars['Float']['output']>;
  /** Resort fee period (daily, weekly, stay) */
  resort_period?: Maybe<Scalars['String']['output']>;
  /** Resort fee type (flat, per_night, etc.) */
  resort_type?: Maybe<Scalars['String']['output']>;
};

/** Input for resort fee structure. */
export type ResortFeesInput = {
  /** Parking fee */
  parking?: InputMaybe<Scalars['Float']['input']>;
  /** Resort fee amount */
  resort?: InputMaybe<Scalars['Float']['input']>;
  /** Resort fee period */
  resort_period?: InputMaybe<Scalars['String']['input']>;
  /** Resort fee type */
  resort_type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for creating or updating a resort.
 * Only include fields you want to set or update.
 */
export type ResortInput = {
  /** Physical address */
  address?: InputMaybe<AddressInput>;
  /** Full HTML body content */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when created */
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Short description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Amenities and features */
  features?: InputMaybe<Array<FeatureDetailInput>>;
  /** Fee structure */
  fees?: InputMaybe<ResortFeesInput>;
  /** Unique identifier (required) */
  id: Scalars['String']['input'];
  /** Resort images */
  images?: InputMaybe<Array<ImageInput>>;
  /** Locale identifier */
  locale_id?: InputMaybe<Scalars['String']['input']>;
  /** Locale name */
  locale_name?: InputMaybe<Scalars['String']['input']>;
  /** Geographic coordinates */
  location?: InputMaybe<GeoPointInput>;
  /** Property manager ID (determines access control) */
  manager_id?: InputMaybe<Scalars['String']['input']>;
  /** Property manager name */
  manager_name?: InputMaybe<Scalars['String']['input']>;
  /** Marketing content */
  marketing?: InputMaybe<ResortMarketingInfoInput>;
  /** Timestamp of last modification */
  modified_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Internal name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Region identifier */
  region_id?: InputMaybe<Scalars['String']['input']>;
  /** Region name */
  region_name?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show on public website */
  show_on_web?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL-friendly slug */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Current status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Resort sub-type */
  sub_type?: InputMaybe<Scalars['String']['input']>;
  /** Tax registration ID */
  tax_id?: InputMaybe<Scalars['String']['input']>;
  /** Display title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Resort type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Video URLs */
  video_url?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Marketing content for a resort. */
export type ResortMarketingInfo = {
  __typename?: 'ResortMarketingInfo';
  /** Marketing common name */
  common_name?: Maybe<Scalars['String']['output']>;
  /** Facility/amenities description */
  desc_facility?: Maybe<Scalars['String']['output']>;
  /** Location description */
  desc_location?: Maybe<Scalars['String']['output']>;
  /** Description shown after listing content */
  desc_post_listing?: Maybe<Scalars['String']['output']>;
  /** Description shown before listing content */
  desc_pre_listing?: Maybe<Scalars['String']['output']>;
  /** Primary description */
  desc_primary?: Maybe<Scalars['String']['output']>;
  /** Transportation/directions description */
  desc_transport?: Maybe<Scalars['String']['output']>;
  /** First disclaimer shown after content */
  disclaimer_post_one?: Maybe<Scalars['String']['output']>;
  /** Second disclaimer shown after content */
  disclaimer_post_two?: Maybe<Scalars['String']['output']>;
  /** Disclaimer shown before content */
  disclaimer_pre?: Maybe<Scalars['String']['output']>;
  /** Primary marketing pitch/tagline */
  primary_pitch?: Maybe<Scalars['String']['output']>;
};

/** Input for resort marketing content. */
export type ResortMarketingInfoInput = {
  /** Marketing common name */
  common_name?: InputMaybe<Scalars['String']['input']>;
  /** Facility description */
  desc_facility?: InputMaybe<Scalars['String']['input']>;
  /** Location description */
  desc_location?: InputMaybe<Scalars['String']['input']>;
  /** Post-listing description */
  desc_post_listing?: InputMaybe<Scalars['String']['input']>;
  /** Pre-listing description */
  desc_pre_listing?: InputMaybe<Scalars['String']['input']>;
  /** Primary description */
  desc_primary?: InputMaybe<Scalars['String']['input']>;
  /** Transportation description */
  desc_transport?: InputMaybe<Scalars['String']['input']>;
  /** Post disclaimer one */
  disclaimer_post_one?: InputMaybe<Scalars['String']['input']>;
  /** Post disclaimer two */
  disclaimer_post_two?: InputMaybe<Scalars['String']['input']>;
  /** Pre disclaimer */
  disclaimer_pre?: InputMaybe<Scalars['String']['input']>;
  /** Primary marketing pitch */
  primary_pitch?: InputMaybe<Scalars['String']['input']>;
};

/** Available fields for sorting resort results. */
export enum ResortSortField {
  /** Sort alphabetically by title */
  Title = 'TITLE'
}

/** Sorting options for resort queries. */
export type ResortSortInput = {
  /** The field to sort by */
  field?: InputMaybe<ResortSortField>;
  /** Sort direction (ASC or DESC) */
  order?: InputMaybe<SortOrder>;
};

/** Filter criteria for resort queries. All filters are combined with AND logic. */
export type ResortsFiltersInput = {
  /** Filter by property manager IDs */
  manager_ids?: InputMaybe<FilterStringInput>;
  /** Filter by specific resort IDs */
  resort_ids?: InputMaybe<FilterStringInput>;
  /** Filter by web visibility status */
  show_on_web?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by URL slug */
  slug?: InputMaybe<FilterStringInput>;
};

/** Input for querying resorts with filtering, sorting, and pagination. */
export type ResortsQueryInput = {
  /** Filter criteria to narrow results */
  filters?: InputMaybe<ResortsFiltersInput>;
  /** Pagination controls */
  page?: InputMaybe<PageInput>;
  /** Sort criteria applied in order */
  sorts?: InputMaybe<Array<ResortSortInput>>;
};

/** Response from a resorts query. */
export type ResortsQueryOutput = {
  __typename?: 'ResortsQueryOutput';
  /** Array of resorts matching the query criteria */
  resorts: Array<Resort>;
};

/** Room details including bed configuration. */
export type Room = {
  __typename?: 'Room';
  /** Number of bunk beds */
  beds_bunk?: Maybe<Scalars['Int']['output']>;
  /** Number of couches */
  beds_couch?: Maybe<Scalars['Int']['output']>;
  /** Number of cribs */
  beds_crib?: Maybe<Scalars['Int']['output']>;
  /** Number of double beds */
  beds_double?: Maybe<Scalars['Int']['output']>;
  /** Number of hammocks */
  beds_hammock?: Maybe<Scalars['Int']['output']>;
  /** Number of king beds */
  beds_king?: Maybe<Scalars['Int']['output']>;
  /** Number of queen beds */
  beds_queen?: Maybe<Scalars['Int']['output']>;
  /** Number of single/twin beds */
  beds_single?: Maybe<Scalars['Int']['output']>;
  /** Number of sofa beds */
  beds_sofa?: Maybe<Scalars['Int']['output']>;
  /** Total number of beds in this room */
  beds_total?: Maybe<Scalars['Int']['output']>;
  /** Room-specific features */
  features?: Maybe<Array<Scalars['String']['output']>>;
  /** Room name (e.g., Master Bedroom) */
  name?: Maybe<Scalars['String']['output']>;
  /** Additional notes about the room */
  notes?: Maybe<Scalars['String']['output']>;
  /** Room sub-type for more detail */
  sub_type?: Maybe<Scalars['String']['output']>;
  /** Room type (e.g., bedroom, living room) */
  type?: Maybe<Scalars['String']['output']>;
};

/** Input for creating/updating room details. */
export type RoomInput = {
  /** Bunk beds */
  beds_bunk?: InputMaybe<Scalars['Int']['input']>;
  /** Couches */
  beds_couch?: InputMaybe<Scalars['Int']['input']>;
  /** Cribs */
  beds_crib?: InputMaybe<Scalars['Int']['input']>;
  /** Double beds */
  beds_double?: InputMaybe<Scalars['Int']['input']>;
  /** Hammocks */
  beds_hammock?: InputMaybe<Scalars['Int']['input']>;
  /** King beds */
  beds_king?: InputMaybe<Scalars['Int']['input']>;
  /** Queen beds */
  beds_queen?: InputMaybe<Scalars['Int']['input']>;
  /** Single/twin beds */
  beds_single?: InputMaybe<Scalars['Int']['input']>;
  /** Sofa beds */
  beds_sofa?: InputMaybe<Scalars['Int']['input']>;
  /** Total beds */
  beds_total?: InputMaybe<Scalars['Int']['input']>;
  /** Room features */
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Room name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Room sub-type */
  sub_type?: InputMaybe<Scalars['String']['input']>;
  /** Room type */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Sort direction for query results. */
export enum SortOrder {
  /** Ascending order (A-Z, 1-9, oldest first) */
  Asc = 'ASC',
  /** Descending order (Z-A, 9-1, newest first) */
  Desc = 'DESC'
}

/**
 * Filter criteria for finding available stays.
 * Use to search for listings available for specific dates and guest counts.
 */
export type StayFilter = {
  /** Desired check-in date */
  check_in?: InputMaybe<Scalars['Date']['input']>;
  /** Desired check-out date */
  check_out?: InputMaybe<Scalars['Date']['input']>;
  /** Allow flexible date matching */
  flex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of guests */
  guests?: InputMaybe<Scalars['Int']['input']>;
  /** Number of nights for the stay */
  nights?: InputMaybe<Scalars['Int']['input']>;
};

/** A range of stay lengths available for booking. */
export type StayRange = {
  __typename?: 'StayRange';
  /** First (minimum) number of nights in this range */
  first: Scalars['Int']['output'];
  /** Last (maximum) number of nights in this range */
  last: Scalars['Int']['output'];
};

/**
 * Defines a range of stay lengths (in nights) that are available for booking.
 * Used to specify complex availability patterns like "3-5 nights OR 7 nights".
 */
export type StayRangeInput = {
  /** First (minimum) number of nights in this range */
  first: Scalars['Int']['input'];
  /** Last (maximum) number of nights in this range */
  last: Scalars['Int']['input'];
};

/** Input for triggering a listing index rebuild. */
export type UpdateListingIndexesInput = {
  /** Optional list of manager IDs to limit the index update scope */
  manager_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response from an index update operation. */
export type UpdateListingIndexesResponse = {
  __typename?: 'UpdateListingIndexesResponse';
  /** Whether the index update completed successfully */
  success: Scalars['Boolean']['output'];
};

export type FragmentListingCardFragment = { __typename?: 'Listing', id: string, resort_id?: string | null, resort_name?: string | null, slug?: string | null, name?: string | null, name_detailed?: string | null, type?: string | null, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, building_name?: string | null, show_on_web?: boolean | null, is_hybrid?: boolean | null, hybrid_child_ids?: Array<string> | null, unit_view?: string | null, area_sqft?: number | null, locale_id?: string | null, locale_name?: string | null, effective_date?: any | null, unit_type?: string | null, rate_summary?: { __typename?: 'ListingRateSummary', min_total_nt?: number | null, max_total_nt?: number | null } | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, default_image?: { __typename?: 'Image', caption?: string | null, url?: string | null } | null, fees?: { __typename?: 'ListingFees', cleaning?: number | null, cleaning_daily?: number | null, damage?: number | null, service_pct?: number | null, booking_pct?: number | null } | null, images?: Array<{ __typename?: 'Image', external_id?: string | null, caption?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null, short_name?: string | null } | null, resort?: { __typename?: 'Resort', slug?: string | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null } | null } | null };

export type FragmentListingLocationFragment = { __typename?: 'Listing', id: string, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, unit_view?: string | null, unit_type?: string | null, resort_name?: string | null, locale_name?: string | null, slug?: string | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null } | null, images?: Array<{ __typename?: 'Image', url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null };

export type FragmentListingDetailFragment = { __typename?: 'Listing', id: string, resort_id?: string | null, resort_name?: string | null, name?: string | null, name_detailed?: string | null, slug?: string | null, type?: string | null, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, building_name?: string | null, unit_view?: string | null, area_sqft?: number | null, show_on_web?: boolean | null, is_hybrid?: boolean | null, hybrid_child_ids?: Array<string> | null, locale_id?: string | null, locale_name?: string | null, tax_permit_id?: string | null, effective_date?: any | null, video_url?: Array<string> | null, virtual_tour_url?: string | null, booking_lead_time?: number | null, check_in_time?: string | null, unit_type?: string | null, average_rating?: number | null, description?: string | null, manager_name?: string | null, sub_type?: string | null, is_group?: boolean | null, is_timeshare?: boolean | null, cancellation_policy?: { __typename?: 'CancellationPolicy', refund_percent: number, nights_before_check_in: number, grace_period: number, fully_refundable: boolean } | null, rate_summary?: { __typename?: 'ListingRateSummary', min_total_nt?: number | null, max_total_nt?: number | null } | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, default_image?: { __typename?: 'Image', caption?: string | null, url?: string | null } | null, fees?: { __typename?: 'ListingFees', cleaning?: number | null, cleaning_daily?: number | null, damage?: number | null, service_pct?: number | null, booking_pct?: number | null } | null, images?: Array<{ __typename?: 'Image', external_id?: string | null, caption?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null, resort?: { __typename?: 'Resort', slug?: string | null, fees?: { __typename?: 'ResortFees', parking?: number | null, resort_period?: string | null, resort?: number | null, resort_type?: string | null } | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null, desc_pre_listing?: string | null, disclaimer_pre?: string | null, desc_facility?: string | null, desc_location?: string | null, desc_transport?: string | null, disclaimer_post_one?: string | null, disclaimer_post_two?: string | null, desc_post_listing?: string | null } | null } | null, reviews?: Array<{ __typename?: 'ListingReview', rating: number, reviewer?: string | null, review_response?: string | null, source?: string | null, submitted_date?: any | null, text: string, title?: string | null }> | null, features?: Array<{ __typename?: 'FeatureDetail', category?: string | null, detail?: string | null, name: string, value: string }> | null, rooms?: Array<{ __typename?: 'Room', beds_bunk?: number | null, beds_couch?: number | null, beds_crib?: number | null, beds_double?: number | null, beds_hammock?: number | null, beds_king?: number | null, beds_queen?: number | null, beds_single?: number | null, beds_sofa?: number | null, beds_total?: number | null, name?: string | null, features?: Array<string> | null, notes?: string | null, sub_type?: string | null, type?: string | null }> | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, postal_code?: string | null, state_prov?: string | null, street?: string | null, street2?: string | null } | null, calendar_dates?: Array<{ __typename?: 'CalendarDate', available: boolean, cal_date: any, checkout?: boolean | null, min_stay?: number | null, stay_ranges?: Array<{ __typename?: 'StayRange', first: number, last: number }> | null }> | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null, desc_facility?: string | null, desc_location?: string | null, desc_primary?: string | null, desc_transport?: string | null, disclaimer_pre?: string | null, disclaimer_post_one?: string | null, disclaimer_post_two?: string | null, primary_pitch?: string | null } | null };

export type FragmentListingLosFragment = { __typename?: 'ListingLOS', id: string, max_amount?: number | null, min_amount?: number | null, los: Array<{ __typename?: 'LOS', cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null, fee_details?: { __typename?: 'RateFeeDetails', clean?: number | null, cleaning_daily?: number | null, damage?: number | null, resort?: number | null, service?: number | null, booking?: number | null, total?: number | null, stay_collected_fees?: Array<FeeType> | null, stay_collected_total?: number | null } | null }> }>, fee_details?: { __typename?: 'ListingFeeDetails', clean?: number | null, damage?: number | null, resort_flat?: number | null, resort_daily?: number | null, service_pct?: number | null, booking_pct?: number | null } | null };

export type FragmentListingLosSummaryFragment = { __typename?: 'ListingLOS', id: string, max_amount?: number | null, min_amount?: number | null, los: Array<{ __typename?: 'LOS', cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null, fee_details?: { __typename?: 'RateFeeDetails', clean?: number | null, cleaning_daily?: number | null, damage?: number | null, resort?: number | null, service?: number | null, booking?: number | null, total?: number | null } | null }> }> };

export type FragmentListingsFacetsFragment = { __typename?: 'ListingsFacets', price_max?: number | null, price_min?: number | null, bathrooms?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, bedrooms?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, beds?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, features?: Array<{ __typename?: 'FacetFeature', count: number, value: string }> | null, locales?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null, max_pets?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, price_buckets?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, max_guests?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, regions?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null, resorts?: Array<{ __typename?: 'FacetResort', count: number, id: string, name: string }> | null, unit_types?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null, unit_views?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null };

export type FragmentListingsPriceFacetsFragment = { __typename?: 'ListingsFacets', price_max?: number | null, price_min?: number | null };

export type FragmentResortDetailFragment = { __typename?: 'Resort', description?: string | null, id: string, video_url?: Array<string> | null, manager_name?: string | null, name?: string | null, tax_id?: string | null, title?: string | null, slug?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, postal_code?: string | null, state_prov?: string | null, street?: string | null, street2?: string | null } | null, features?: Array<{ __typename?: 'FeatureDetail', category?: string | null, detail?: string | null, name: string, value: string }> | null, fees?: { __typename?: 'ResortFees', resort_period?: string | null, resort_type?: string | null, resort?: number | null, parking?: number | null } | null, images?: Array<{ __typename?: 'Image', caption?: string | null, category?: string | null, external_id?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', width?: number | null, height?: number | null } | null }> | null, location?: { __typename?: 'GeoPoint', lon?: number | null, lat?: number | null } | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null, primary_pitch?: string | null } | null };

export type RegisterEndUserMutationVariables = Exact<{
  input: EndUserContextInput;
}>;


export type RegisterEndUserMutation = { __typename?: 'Mutation', registerEndUser: { __typename?: 'RegisterEndUserOutput', success: boolean, cached_count?: number | null, cohort?: string | null } };

export type QueryAnnouncementsQueryVariables = Exact<{
  input?: InputMaybe<AnnouncementsQueryInput>;
}>;


export type QueryAnnouncementsQuery = { __typename?: 'Query', announcements: { __typename?: 'AnnouncementsQueryOutput', announcements: Array<{ __typename?: 'Announcement', active?: boolean | null, name?: string | null, details?: string | null, type?: string | null, cta_url?: string | null, cta_text?: string | null, uuid?: string | null, start_datetime?: any | null, end_datetime?: any | null }> } };

export type QueryListingLosRatesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  losRatesInput?: InputMaybe<LosRatesArgsInput>;
}>;


export type QueryListingLosRatesQuery = { __typename?: 'Query', listingBySlug?: { __typename?: 'Listing', id: string, los_rates?: Array<{ __typename?: 'LOS', max_guests: number, cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null }> }> | null } | null };

export type QueryListingsCancellationPolicyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QueryListingsCancellationPolicyQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', booking_lead_time?: number | null, check_in_time?: string | null, max_guests?: number | null, cancellation_policy?: { __typename?: 'CancellationPolicy', refund_percent: number, nights_before_check_in: number, grace_period: number, fully_refundable: boolean } | null, calendar_dates?: Array<{ __typename?: 'CalendarDate', available: boolean, cal_date: any, checkout?: boolean | null, min_stay?: number | null, stay_ranges?: Array<{ __typename?: 'StayRange', first: number, last: number }> | null }> | null } | null };

export type QueryListingsDetailQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
  calendarDatesInput?: InputMaybe<CalendarDatesArgsInput>;
}>;


export type QueryListingsDetailQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', listings: Array<{ __typename?: 'Listing', id: string, resort_id?: string | null, resort_name?: string | null, name?: string | null, name_detailed?: string | null, slug?: string | null, type?: string | null, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, building_name?: string | null, unit_view?: string | null, area_sqft?: number | null, show_on_web?: boolean | null, is_hybrid?: boolean | null, hybrid_child_ids?: Array<string> | null, locale_id?: string | null, locale_name?: string | null, tax_permit_id?: string | null, effective_date?: any | null, video_url?: Array<string> | null, virtual_tour_url?: string | null, booking_lead_time?: number | null, check_in_time?: string | null, unit_type?: string | null, average_rating?: number | null, description?: string | null, manager_name?: string | null, sub_type?: string | null, is_group?: boolean | null, is_timeshare?: boolean | null, cancellation_policy?: { __typename?: 'CancellationPolicy', refund_percent: number, nights_before_check_in: number, grace_period: number, fully_refundable: boolean } | null, rate_summary?: { __typename?: 'ListingRateSummary', min_total_nt?: number | null, max_total_nt?: number | null } | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, default_image?: { __typename?: 'Image', caption?: string | null, url?: string | null } | null, fees?: { __typename?: 'ListingFees', cleaning?: number | null, cleaning_daily?: number | null, damage?: number | null, service_pct?: number | null, booking_pct?: number | null } | null, images?: Array<{ __typename?: 'Image', external_id?: string | null, caption?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null, resort?: { __typename?: 'Resort', slug?: string | null, fees?: { __typename?: 'ResortFees', parking?: number | null, resort_period?: string | null, resort?: number | null, resort_type?: string | null } | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null, desc_pre_listing?: string | null, disclaimer_pre?: string | null, desc_facility?: string | null, desc_location?: string | null, desc_transport?: string | null, disclaimer_post_one?: string | null, disclaimer_post_two?: string | null, desc_post_listing?: string | null } | null } | null, reviews?: Array<{ __typename?: 'ListingReview', rating: number, reviewer?: string | null, review_response?: string | null, source?: string | null, submitted_date?: any | null, text: string, title?: string | null }> | null, features?: Array<{ __typename?: 'FeatureDetail', category?: string | null, detail?: string | null, name: string, value: string }> | null, rooms?: Array<{ __typename?: 'Room', beds_bunk?: number | null, beds_couch?: number | null, beds_crib?: number | null, beds_double?: number | null, beds_hammock?: number | null, beds_king?: number | null, beds_queen?: number | null, beds_single?: number | null, beds_sofa?: number | null, beds_total?: number | null, name?: string | null, features?: Array<string> | null, notes?: string | null, sub_type?: string | null, type?: string | null }> | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, postal_code?: string | null, state_prov?: string | null, street?: string | null, street2?: string | null } | null, calendar_dates?: Array<{ __typename?: 'CalendarDate', available: boolean, cal_date: any, checkout?: boolean | null, min_stay?: number | null, stay_ranges?: Array<{ __typename?: 'StayRange', first: number, last: number }> | null }> | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null, desc_facility?: string | null, desc_location?: string | null, desc_primary?: string | null, desc_transport?: string | null, disclaimer_pre?: string | null, disclaimer_post_one?: string | null, disclaimer_post_two?: string | null, primary_pitch?: string | null } | null }>, rates?: Array<{ __typename?: 'ListingLOS', id: string, max_amount?: number | null, min_amount?: number | null, los: Array<{ __typename?: 'LOS', cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null, fee_details?: { __typename?: 'RateFeeDetails', clean?: number | null, cleaning_daily?: number | null, damage?: number | null, resort?: number | null, service?: number | null, booking?: number | null, total?: number | null, stay_collected_fees?: Array<FeeType> | null, stay_collected_total?: number | null } | null }> }>, fee_details?: { __typename?: 'ListingFeeDetails', clean?: number | null, damage?: number | null, resort_flat?: number | null, resort_daily?: number | null, service_pct?: number | null, booking_pct?: number | null } | null }> | null } };

export type QueryListingsIndexQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
}>;


export type QueryListingsIndexQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', listings: Array<{ __typename?: 'Listing', id: string, resort_name?: string | null, slug?: string | null, name?: string | null, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, title?: string | null, effective_date?: any | null, rate_summary?: { __typename?: 'ListingRateSummary', min_total_nt?: number | null, max_total_nt?: number | null } | null }>, page?: { __typename?: 'PageOutput', size?: number | null, total?: number | null, offset?: number | null } | null } };

export type QueryListingsMapLocationsQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
  imagesInput?: InputMaybe<ArrayArgsInput>;
}>;


export type QueryListingsMapLocationsQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', listings: Array<{ __typename?: 'Listing', id: string, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, unit_view?: string | null, unit_type?: string | null, resort_name?: string | null, locale_name?: string | null, slug?: string | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null } | null, images?: Array<{ __typename?: 'Image', url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null }> } };

export type QueryListingsPriceRangeQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
}>;


export type QueryListingsPriceRangeQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', rates?: Array<{ __typename?: 'ListingLOS', id: string, max_amount?: number | null, min_amount?: number | null, los: Array<{ __typename?: 'LOS', cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null, fee_details?: { __typename?: 'RateFeeDetails', clean?: number | null, cleaning_daily?: number | null, damage?: number | null, resort?: number | null, service?: number | null, booking?: number | null, total?: number | null } | null }> }> }> | null, facets?: { __typename?: 'ListingsFacets', price_max?: number | null, price_min?: number | null } | null } };

export type QueryListingsRatesAndLocationsQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
  imagesInput?: InputMaybe<ArrayArgsInput>;
}>;


export type QueryListingsRatesAndLocationsQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', listings: Array<{ __typename?: 'Listing', id: string, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, unit_view?: string | null, unit_type?: string | null, resort_name?: string | null, locale_name?: string | null, slug?: string | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null } | null, images?: Array<{ __typename?: 'Image', url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null }>, rates?: Array<{ __typename?: 'ListingLOS', id: string, max_amount?: number | null, min_amount?: number | null, los: Array<{ __typename?: 'LOS', cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null, fee_details?: { __typename?: 'RateFeeDetails', clean?: number | null, cleaning_daily?: number | null, damage?: number | null, resort?: number | null, service?: number | null, booking?: number | null, total?: number | null } | null }> }> }> | null, page?: { __typename?: 'PageOutput', size?: number | null, total?: number | null, offset?: number | null } | null } };

export type QueryListingsReconcileQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
}>;


export type QueryListingsReconcileQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', listings: Array<{ __typename?: 'Listing', id: string, show_on_web?: boolean | null, listing_status?: string | null }>, page?: { __typename?: 'PageOutput', size?: number | null, total?: number | null, offset?: number | null } | null } };

export type QueryListingsSearchQueryVariables = Exact<{
  input?: InputMaybe<ListingsQueryInput>;
  imagesInput?: InputMaybe<ArrayArgsInput>;
}>;


export type QueryListingsSearchQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsQueryOutput', cohort?: string | null, listings: Array<{ __typename?: 'Listing', id: string, resort_id?: string | null, resort_name?: string | null, slug?: string | null, name?: string | null, name_detailed?: string | null, type?: string | null, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, building_name?: string | null, show_on_web?: boolean | null, is_hybrid?: boolean | null, hybrid_child_ids?: Array<string> | null, unit_view?: string | null, area_sqft?: number | null, locale_id?: string | null, locale_name?: string | null, effective_date?: any | null, unit_type?: string | null, rate_summary?: { __typename?: 'ListingRateSummary', min_total_nt?: number | null, max_total_nt?: number | null } | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, default_image?: { __typename?: 'Image', caption?: string | null, url?: string | null } | null, fees?: { __typename?: 'ListingFees', cleaning?: number | null, cleaning_daily?: number | null, damage?: number | null, service_pct?: number | null, booking_pct?: number | null } | null, images?: Array<{ __typename?: 'Image', external_id?: string | null, caption?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null, short_name?: string | null } | null, resort?: { __typename?: 'Resort', slug?: string | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null } | null } | null }>, rates?: Array<{ __typename?: 'ListingLOS', id: string, max_amount?: number | null, min_amount?: number | null, los: Array<{ __typename?: 'LOS', cal_date: any, rates: Array<{ __typename?: 'Rate', amount: number, nights: number, discount?: number | null, fee_details?: { __typename?: 'RateFeeDetails', clean?: number | null, cleaning_daily?: number | null, damage?: number | null, resort?: number | null, service?: number | null, booking?: number | null, total?: number | null, stay_collected_fees?: Array<FeeType> | null, stay_collected_total?: number | null } | null }> }>, fee_details?: { __typename?: 'ListingFeeDetails', clean?: number | null, damage?: number | null, resort_flat?: number | null, resort_daily?: number | null, service_pct?: number | null, booking_pct?: number | null } | null }> | null, page?: { __typename?: 'PageOutput', size?: number | null, total?: number | null, offset?: number | null } | null, facets?: { __typename?: 'ListingsFacets', price_max?: number | null, price_min?: number | null, bathrooms?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, bedrooms?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, beds?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, features?: Array<{ __typename?: 'FacetFeature', count: number, value: string }> | null, locales?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null, max_pets?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, price_buckets?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, max_guests?: Array<{ __typename?: 'FacetNumber', count: number, value: number }> | null, regions?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null, resorts?: Array<{ __typename?: 'FacetResort', count: number, id: string, name: string }> | null, unit_types?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null, unit_views?: Array<{ __typename?: 'FacetString', count: number, value: string }> | null } | null, tracking?: Array<{ __typename?: 'ListingTracking', listing_id: string, impression_tracker_url?: string | null, click_tracker_url?: string | null }> | null } };

export type QueryRecommendedListingsQueryVariables = Exact<{
  input: RecommendedListingsInput;
  imagesInput?: InputMaybe<ArrayArgsInput>;
}>;


export type QueryRecommendedListingsQuery = { __typename?: 'Query', recommendedListings: { __typename?: 'RecommendedListingsOutput', cohort?: string | null, listings: Array<{ __typename?: 'Listing', id: string, resort_id?: string | null, resort_name?: string | null, slug?: string | null, name?: string | null, name_detailed?: string | null, type?: string | null, bedrooms?: number | null, bathrooms?: number | null, max_guests?: number | null, max_pets?: number | null, building_name?: string | null, show_on_web?: boolean | null, is_hybrid?: boolean | null, hybrid_child_ids?: Array<string> | null, unit_view?: string | null, area_sqft?: number | null, locale_id?: string | null, locale_name?: string | null, effective_date?: any | null, unit_type?: string | null, rate_summary?: { __typename?: 'ListingRateSummary', min_total_nt?: number | null, max_total_nt?: number | null } | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null, default_image?: { __typename?: 'Image', caption?: string | null, url?: string | null } | null, fees?: { __typename?: 'ListingFees', cleaning?: number | null, cleaning_daily?: number | null, damage?: number | null, service_pct?: number | null, booking_pct?: number | null } | null, images?: Array<{ __typename?: 'Image', external_id?: string | null, caption?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', height?: number | null, width?: number | null } | null }> | null, marketing?: { __typename?: 'ListingMarketingInfo', common_name?: string | null, short_name?: string | null } | null, resort?: { __typename?: 'Resort', slug?: string | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null } | null } | null }>, tracking?: Array<{ __typename?: 'ListingTracking', listing_id: string, impression_tracker_url?: string | null, click_tracker_url?: string | null }> | null } };

export type QueryResortDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QueryResortDetailQuery = { __typename?: 'Query', resort?: { __typename?: 'Resort', description?: string | null, id: string, video_url?: Array<string> | null, manager_name?: string | null, name?: string | null, tax_id?: string | null, title?: string | null, slug?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, postal_code?: string | null, state_prov?: string | null, street?: string | null, street2?: string | null } | null, features?: Array<{ __typename?: 'FeatureDetail', category?: string | null, detail?: string | null, name: string, value: string }> | null, fees?: { __typename?: 'ResortFees', resort_period?: string | null, resort_type?: string | null, resort?: number | null, parking?: number | null } | null, images?: Array<{ __typename?: 'Image', caption?: string | null, category?: string | null, external_id?: string | null, url?: string | null, size?: { __typename?: 'ImageSize', width?: number | null, height?: number | null } | null }> | null, location?: { __typename?: 'GeoPoint', lon?: number | null, lat?: number | null } | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null, primary_pitch?: string | null } | null } | null };

export type QueryResortsIndexQueryVariables = Exact<{
  input?: InputMaybe<ResortsQueryInput>;
  countShowOnWeb?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QueryResortsIndexQuery = { __typename?: 'Query', resorts: { __typename?: 'ResortsQueryOutput', resorts: Array<{ __typename?: 'Resort', id: string, slug?: string | null, name?: string | null, listings_count?: number | null }> } };

export type QueryResortsSearchQueryVariables = Exact<{
  input?: InputMaybe<ResortsQueryInput>;
  imagesInput?: InputMaybe<ArrayArgsInput>;
}>;


export type QueryResortsSearchQuery = { __typename?: 'Query', resorts: { __typename?: 'ResortsQueryOutput', resorts: Array<{ __typename?: 'Resort', id: string, name?: string | null, slug?: string | null, title?: string | null, listings_count?: number | null, region_name?: string | null, locale_name?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, postal_code?: string | null, state_prov?: string | null, street?: string | null, street2?: string | null } | null, marketing?: { __typename?: 'ResortMarketingInfo', common_name?: string | null, primary_pitch?: string | null } | null, images?: Array<{ __typename?: 'Image', caption?: string | null, external_id?: string | null, url?: string | null, category?: string | null, size?: { __typename?: 'ImageSize', width?: number | null, height?: number | null } | null }> | null, location?: { __typename?: 'GeoPoint', lat?: number | null, lon?: number | null } | null }> } };

export const FragmentListingCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name_detailed"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"building_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_on_web"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_child_ids"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"area_sqft"}},{"kind":"Field","name":{"kind":"Name","value":"locale_id"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"effective_date"}},{"kind":"Field","name":{"kind":"Name","value":"rate_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_total_nt"}},{"kind":"Field","name":{"kind":"Name","value":"max_total_nt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleaning"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}}]}}]}}]}}]} as unknown as DocumentNode<FragmentListingCardFragment, unknown>;
export const FragmentListingLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]}}]} as unknown as DocumentNode<FragmentListingLocationFragment, unknown>;
export const FragmentListingDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name_detailed"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"building_name"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"area_sqft"}},{"kind":"Field","name":{"kind":"Name","value":"show_on_web"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_child_ids"}},{"kind":"Field","name":{"kind":"Name","value":"locale_id"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"tax_permit_id"}},{"kind":"Field","name":{"kind":"Name","value":"effective_date"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_tour_url"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refund_percent"}},{"kind":"Field","name":{"kind":"Name","value":"nights_before_check_in"}},{"kind":"Field","name":{"kind":"Name","value":"grace_period"}},{"kind":"Field","name":{"kind":"Name","value":"fully_refundable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_total_nt"}},{"kind":"Field","name":{"kind":"Name","value":"max_total_nt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_lead_time"}},{"kind":"Field","name":{"kind":"Name","value":"check_in_time"}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleaning"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parking"}},{"kind":"Field","name":{"kind":"Name","value":"resort_period"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"resort_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"reviewer"}},{"kind":"Field","name":{"kind":"Name","value":"review_response"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_date"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"average_rating"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager_name"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beds_bunk"}},{"kind":"Field","name":{"kind":"Name","value":"beds_couch"}},{"kind":"Field","name":{"kind":"Name","value":"beds_crib"}},{"kind":"Field","name":{"kind":"Name","value":"beds_double"}},{"kind":"Field","name":{"kind":"Name","value":"beds_hammock"}},{"kind":"Field","name":{"kind":"Name","value":"beds_king"}},{"kind":"Field","name":{"kind":"Name","value":"beds_queen"}},{"kind":"Field","name":{"kind":"Name","value":"beds_single"}},{"kind":"Field","name":{"kind":"Name","value":"beds_sofa"}},{"kind":"Field","name":{"kind":"Name","value":"beds_total"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"sub_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sub_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_group"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"is_timeshare"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_prov"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calendar_dates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calendarDatesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}},{"kind":"Field","name":{"kind":"Name","value":"min_stay"}},{"kind":"Field","name":{"kind":"Name","value":"stay_ranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"last"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"desc_facility"}},{"kind":"Field","name":{"kind":"Name","value":"desc_location"}},{"kind":"Field","name":{"kind":"Name","value":"desc_primary"}},{"kind":"Field","name":{"kind":"Name","value":"desc_transport"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_pre"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_one"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_two"}},{"kind":"Field","name":{"kind":"Name","value":"primary_pitch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"desc_pre_listing"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_pre"}},{"kind":"Field","name":{"kind":"Name","value":"desc_facility"}},{"kind":"Field","name":{"kind":"Name","value":"desc_location"}},{"kind":"Field","name":{"kind":"Name","value":"desc_transport"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_one"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_two"}},{"kind":"Field","name":{"kind":"Name","value":"desc_post_listing"}}]}}]}}]}}]} as unknown as DocumentNode<FragmentListingDetailFragment, unknown>;
export const FragmentListingLosFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLOS"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingLOS"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"stay_collected_fees"}},{"kind":"Field","name":{"kind":"Name","value":"stay_collected_total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_amount"}},{"kind":"Field","name":{"kind":"Name","value":"min_amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort_flat"}},{"kind":"Field","name":{"kind":"Name","value":"resort_daily"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}}]}}]} as unknown as DocumentNode<FragmentListingLosFragment, unknown>;
export const FragmentListingLosSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLOSSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingLOS"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_amount"}},{"kind":"Field","name":{"kind":"Name","value":"min_amount"}}]}}]} as unknown as DocumentNode<FragmentListingLosSummaryFragment, unknown>;
export const FragmentListingsFacetsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingsFacets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsFacets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bathrooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"beds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_buckets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_max"}},{"kind":"Field","name":{"kind":"Name","value":"price_min"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FragmentListingsFacetsFragment, unknown>;
export const FragmentListingsPriceFacetsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingsPriceFacets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsFacets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_max"}},{"kind":"Field","name":{"kind":"Name","value":"price_min"}}]}}]} as unknown as DocumentNode<FragmentListingsPriceFacetsFragment, unknown>;
export const FragmentResortDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentResortDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resort"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_prov"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resort_period"}},{"kind":"Field","name":{"kind":"Name","value":"resort_type"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"parking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager_name"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_pitch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tax_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<FragmentResortDetailFragment, unknown>;
export const RegisterEndUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterEndUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EndUserContextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerEndUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"cached_count"}},{"kind":"Field","name":{"kind":"Name","value":"cohort"}}]}}]}}]} as unknown as DocumentNode<RegisterEndUserMutation, RegisterEndUserMutationVariables>;
export const QueryAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementsQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cta_url"}},{"kind":"Field","name":{"kind":"Name","value":"cta_text"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"end_datetime"}}]}}]}}]}}]} as unknown as DocumentNode<QueryAnnouncementsQuery, QueryAnnouncementsQueryVariables>;
export const QueryListingLosRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingLOSRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"losRatesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LOSRatesArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los_rates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"losRatesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryListingLosRatesQuery, QueryListingLosRatesQueryVariables>;
export const QueryListingsCancellationPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsCancellationPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking_lead_time"}},{"kind":"Field","name":{"kind":"Name","value":"check_in_time"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refund_percent"}},{"kind":"Field","name":{"kind":"Name","value":"nights_before_check_in"}},{"kind":"Field","name":{"kind":"Name","value":"grace_period"}},{"kind":"Field","name":{"kind":"Name","value":"fully_refundable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calendar_dates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}},{"kind":"Field","name":{"kind":"Name","value":"min_stay"}},{"kind":"Field","name":{"kind":"Name","value":"stay_ranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"last"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryListingsCancellationPolicyQuery, QueryListingsCancellationPolicyQueryVariables>;
export const QueryListingsDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calendarDatesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDatesArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingDetail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingLOS"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name_detailed"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"building_name"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"area_sqft"}},{"kind":"Field","name":{"kind":"Name","value":"show_on_web"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_child_ids"}},{"kind":"Field","name":{"kind":"Name","value":"locale_id"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"tax_permit_id"}},{"kind":"Field","name":{"kind":"Name","value":"effective_date"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_tour_url"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refund_percent"}},{"kind":"Field","name":{"kind":"Name","value":"nights_before_check_in"}},{"kind":"Field","name":{"kind":"Name","value":"grace_period"}},{"kind":"Field","name":{"kind":"Name","value":"fully_refundable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_total_nt"}},{"kind":"Field","name":{"kind":"Name","value":"max_total_nt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_lead_time"}},{"kind":"Field","name":{"kind":"Name","value":"check_in_time"}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleaning"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parking"}},{"kind":"Field","name":{"kind":"Name","value":"resort_period"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"resort_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"reviewer"}},{"kind":"Field","name":{"kind":"Name","value":"review_response"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_date"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"average_rating"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager_name"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beds_bunk"}},{"kind":"Field","name":{"kind":"Name","value":"beds_couch"}},{"kind":"Field","name":{"kind":"Name","value":"beds_crib"}},{"kind":"Field","name":{"kind":"Name","value":"beds_double"}},{"kind":"Field","name":{"kind":"Name","value":"beds_hammock"}},{"kind":"Field","name":{"kind":"Name","value":"beds_king"}},{"kind":"Field","name":{"kind":"Name","value":"beds_queen"}},{"kind":"Field","name":{"kind":"Name","value":"beds_single"}},{"kind":"Field","name":{"kind":"Name","value":"beds_sofa"}},{"kind":"Field","name":{"kind":"Name","value":"beds_total"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"sub_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sub_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_group"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"is_timeshare"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_prov"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calendar_dates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calendarDatesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}},{"kind":"Field","name":{"kind":"Name","value":"min_stay"}},{"kind":"Field","name":{"kind":"Name","value":"stay_ranges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"last"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"desc_facility"}},{"kind":"Field","name":{"kind":"Name","value":"desc_location"}},{"kind":"Field","name":{"kind":"Name","value":"desc_primary"}},{"kind":"Field","name":{"kind":"Name","value":"desc_transport"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_pre"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_one"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_two"}},{"kind":"Field","name":{"kind":"Name","value":"primary_pitch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"desc_pre_listing"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_pre"}},{"kind":"Field","name":{"kind":"Name","value":"desc_facility"}},{"kind":"Field","name":{"kind":"Name","value":"desc_location"}},{"kind":"Field","name":{"kind":"Name","value":"desc_transport"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_one"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer_post_two"}},{"kind":"Field","name":{"kind":"Name","value":"desc_post_listing"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLOS"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingLOS"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"stay_collected_fees"}},{"kind":"Field","name":{"kind":"Name","value":"stay_collected_total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_amount"}},{"kind":"Field","name":{"kind":"Name","value":"min_amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort_flat"}},{"kind":"Field","name":{"kind":"Name","value":"resort_daily"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}}]}}]} as unknown as DocumentNode<QueryListingsDetailQuery, QueryListingsDetailQueryVariables>;
export const QueryListingsIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"effective_date"}},{"kind":"Field","name":{"kind":"Name","value":"rate_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_total_nt"}},{"kind":"Field","name":{"kind":"Name","value":"max_total_nt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}}]}}]}}]} as unknown as DocumentNode<QueryListingsIndexQuery, QueryListingsIndexQueryVariables>;
export const QueryListingsMapLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsMapLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArrayArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingLocation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]}}]} as unknown as DocumentNode<QueryListingsMapLocationsQuery, QueryListingsMapLocationsQueryVariables>;
export const QueryListingsPriceRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsPriceRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingLOSSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingsPriceFacets"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLOSSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingLOS"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_amount"}},{"kind":"Field","name":{"kind":"Name","value":"min_amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingsPriceFacets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsFacets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_max"}},{"kind":"Field","name":{"kind":"Name","value":"price_min"}}]}}]} as unknown as DocumentNode<QueryListingsPriceRangeQuery, QueryListingsPriceRangeQueryVariables>;
export const QueryListingsRatesAndLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsRatesAndLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArrayArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingLOSSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLOSSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingLOS"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_amount"}},{"kind":"Field","name":{"kind":"Name","value":"min_amount"}}]}}]} as unknown as DocumentNode<QueryListingsRatesAndLocationsQuery, QueryListingsRatesAndLocationsQueryVariables>;
export const QueryListingsReconcileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsReconcile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_on_web"}},{"kind":"Field","name":{"kind":"Name","value":"listing_status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}}]}}]}}]} as unknown as DocumentNode<QueryListingsReconcileQuery, QueryListingsReconcileQueryVariables>;
export const QueryListingsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryListingsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArrayArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingLOS"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingsFacets"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"impression_tracker_url"}},{"kind":"Field","name":{"kind":"Name","value":"click_tracker_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cohort"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name_detailed"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"building_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_on_web"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_child_ids"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"area_sqft"}},{"kind":"Field","name":{"kind":"Name","value":"locale_id"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"effective_date"}},{"kind":"Field","name":{"kind":"Name","value":"rate_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_total_nt"}},{"kind":"Field","name":{"kind":"Name","value":"max_total_nt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleaning"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingLOS"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingLOS"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"los"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cal_date"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"stay_collected_fees"}},{"kind":"Field","name":{"kind":"Name","value":"stay_collected_total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_amount"}},{"kind":"Field","name":{"kind":"Name","value":"min_amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clean"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"resort_flat"}},{"kind":"Field","name":{"kind":"Name","value":"resort_daily"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingsFacets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsFacets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bathrooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"beds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_buckets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_max"}},{"kind":"Field","name":{"kind":"Name","value":"price_min"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<QueryListingsSearchQuery, QueryListingsSearchQueryVariables>;
export const QueryRecommendedListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryRecommendedListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendedListingsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArrayArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendedListings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentListingCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"impression_tracker_url"}},{"kind":"Field","name":{"kind":"Name","value":"click_tracker_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cohort"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentListingCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Listing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_id"}},{"kind":"Field","name":{"kind":"Name","value":"resort_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name_detailed"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"max_guests"}},{"kind":"Field","name":{"kind":"Name","value":"max_pets"}},{"kind":"Field","name":{"kind":"Name","value":"building_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_on_web"}},{"kind":"Field","name":{"kind":"Name","value":"is_hybrid"}},{"kind":"Field","name":{"kind":"Name","value":"hybrid_child_ids"}},{"kind":"Field","name":{"kind":"Name","value":"unit_view"}},{"kind":"Field","name":{"kind":"Name","value":"area_sqft"}},{"kind":"Field","name":{"kind":"Name","value":"locale_id"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}},{"kind":"Field","name":{"kind":"Name","value":"effective_date"}},{"kind":"Field","name":{"kind":"Name","value":"rate_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min_total_nt"}},{"kind":"Field","name":{"kind":"Name","value":"max_total_nt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleaning"}},{"kind":"Field","name":{"kind":"Name","value":"cleaning_daily"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"service_pct"}},{"kind":"Field","name":{"kind":"Name","value":"booking_pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}}]}}]}}]}}]} as unknown as DocumentNode<QueryRecommendedListingsQuery, QueryRecommendedListingsQueryVariables>;
export const QueryResortDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryResortDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FragmentResortDetail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FragmentResortDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resort"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_prov"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resort_period"}},{"kind":"Field","name":{"kind":"Name","value":"resort_type"}},{"kind":"Field","name":{"kind":"Name","value":"resort"}},{"kind":"Field","name":{"kind":"Name","value":"parking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager_name"}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_pitch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tax_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<QueryResortDetailQuery, QueryResortDetailQueryVariables>;
export const QueryResortsIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryResortsIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResortsQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countShowOnWeb"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"show_on_web"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countShowOnWeb"}}}]}]}}]}}]}}]} as unknown as DocumentNode<QueryResortsIndexQuery, QueryResortsIndexQueryVariables>;
export const QueryResortsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryResortsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResortsQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArrayArgsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_prov"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"common_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_pitch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listings_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"show_on_web"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"region_name"}},{"kind":"Field","name":{"kind":"Name","value":"locale_name"}}]}}]}}]}}]} as unknown as DocumentNode<QueryResortsSearchQuery, QueryResortsSearchQueryVariables>;